<template>
  <div class="vue-contentido">
    <v-app>
      <v-container v-if="valPunto !== null" grid-list-xl>

        <v-card>
          <v-card-title class="grey lighten-4 py-2">
            <h5 v-if="valPunto != null">
              {{ valPunto.codigo }} - {{ valPunto.nombre }}
            </h5>
          </v-card-title>
        </v-card>
        <br>
        <v-card :loading="loading" :disabled="loading">
          <v-card-text>
            <v-tabs show-arrows next-icon="fa-caret-right" prev-icon="fa-caret-left">
              <v-tabs-slider></v-tabs-slider>
              <v-tab> <v-icon left>dialpad</v-icon>Ficha técnica</v-tab>
              <v-tab> <v-icon left>history</v-icon>Histórico </v-tab>
              <v-tab v-show="this.verauditoria()">
                <v-icon left>fa-glasses</v-icon>Auditoría
              </v-tab>
              <v-tab-item>
                <basicos_cadenavalor :administrar="admineditar"></basicos_cadenavalor>
                <br>
                <v-card flat :elevation="2" :loading="loading" :disabled="loading" outlined>
                  <v-card-title>
                    2. Información general
                  </v-card-title>
                  <v-card-text v-if="valPunto !== null">
                    <v-layout row wrap>
                      <v-flex xs12 sm12 class="col-padd">
                        <label class="tit-requerid">*</label><label
                          class="v-label mx-2 primary--text Label-primary">Descripción del indicador</label>
                        <v-textarea dense v-validate="'required|max:8000'" data-vv-name="descripcion"
                          :error-messages="errors.collect('descripcion')" :counter="8000"
                          :readonly="readcontrol('descripcion') && !admineditar" v-show="showcontrol('descripcion')"
                          v-model="valPunto.descripcion" :clearable="!readcontrol('descripcion')" outlined
                          ref="descripcion"></v-textarea>
                      </v-flex>

                      <v-flex xs12 sm6 class="col-padd">
                        <label class="tit-requerid">*</label><label
                          class="v-label mx-2 primary--text Label-primary">Sector</label>
                        <v-select dense item-text="nombre" :no-data-text="gnodata" :items="gsectores" v-model="sector"
                          outlined :readonly="true" v-validate="'required'" class="field-disabled"></v-select>
                      </v-flex>


                      <v-flex xs6 sm3 class="col-padd">
                        <label class="tit-requerid">*</label><label
                          class="v-label mx-2 primary--text Label-primary">Fecha inicio</label>
                        <v-text-field dense v-model="valPunto.inicio" data-vv-name="inicio"
                          :error-messages="errors.collect('inicio')" v-validate="'required'"
                          :readonly="readcontrol('inicio')" outlined class="field-disabled"></v-text-field>
                      </v-flex>
                      <v-flex xs6 sm3 class="col-padd">
                        <label class="tit-requerid">*</label><label
                          class="v-label mx-2 primary--text Label-primary">Fecha fin</label>
                        <v-text-field dense v-model="valPunto.fin" data-vv-name="fin"
                          :error-messages="errors.collect('fin')" v-validate="'required'" :readonly="readcontrol('fin')"
                          outlined class="field-disabled"></v-text-field>
                      </v-flex>


                      <v-flex xs12 sm12 class="col-padd">
                        <label class="tit-requerid">*</label><label
                          class="v-label mx-2 primary--text Label-primary">Entidad responsable</label>
                        <v-autocomplete dense data-vv-name="responsableselect"
                          :readonly="readcontrol('identidadresponsablepmi')" v-validate="'required'"
                          ref="responsableselect" :error-messages="errors.collect('responsableselect')"
                          v-model="responsableselected" :items="Entidades" item-text="nombre" item-value="identidad"
                          multiple outlined chips deletable-chips
                          class="dx-tag-content field-disabled"></v-autocomplete>
                      </v-flex>

                      <v-flex xs12 sm12 class="col-padd">
                        <label class="v-label mx-2 primary--text Label-primary">Entidades involucradas</label>
                        <v-autocomplete dense data-vv-name="entidadselect" ref="entidadselect"
                          :readonly="readcontrol('entidadinvolucrada')" v-model="Entidadselected" :items="Entidades"
                          item-text="nombre" item-value="identidad" multiple outlined chips deletable-chips
                          class="dx-tag-content field-disabled">
                          <template v-slot:prepend-item>
                            <v-layout>
                              <div style="display: inline-flex; align-items: center;">
                                <v-checkbox v-model="TodasEntidades" class="mx-4"></v-checkbox>
                                <label class="v-label mx-2 list">Seleccionar todo</label>
                              </div>
                            </v-layout>
                            <v-divider></v-divider>
                          </template>
                        </v-autocomplete>
                      </v-flex>


                      <v-flex xs12 sm4 class="col-padd">
                        <label class="tit-requerid">*</label><label
                          class="v-label mx-2 primary--text Label-primary">Tipo Indicador</label>
                        <v-select dense v-validate="'required'" data-vv-name="tipoindicador"
                          :error-messages="errors.collect('tipoindicador')"
                          :readonly="readcontrol('idtipoindicador') && !admineditar"
                          v-show="showcontrol('idtipoindicador')" :items="gtiposindicador"
                          v-model="valPunto.idtipoindicador" item-text="nombre" item-value="idtipoindicador" outlined
                          @change="ChangeTiposIndicador" ref="tipoindicador"></v-select>
                      </v-flex>

                      <v-flex xs12 sm8 class="col-padd" v-if="DescripcionTipoIndicador.length > 0">
                        <label class="v-label mx-2 primary--text Label-primary">Definición de tipo de indicador</label>
                        <v-textarea dense :readonly="true" rows="1" v-model="DescripcionTipoIndicador" class="mx-2"
                          outlined></v-textarea>
                      </v-flex>


                    </v-layout>
                  </v-card-text>
                </v-card>
                <br>
                <v-card flat :elevation="2" :loading="loading" :disabled="loading" outlined>
                  <v-card-title>
                    3. Información de medición
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>

                      <v-flex xs12 sm5 class="col-padd">
                        <label class="tit-requerid">*</label><label
                          class="v-label mx-2 primary--text Label-primary">Unidad de medida</label>
                        <v-select dense v-validate="'required'" data-vv-name="unidadmedida"
                          :error-messages="errors.collect('unidadmedida')"
                          :readonly="readcontrol('idunidad') && !admineditar" v-show="showcontrol('idunidad')"
                          :items="gunidades" v-model="valPunto.idunidad" item-text="nombre" item-value="idunidad"
                          outlined ref="tipoindicador"></v-select>
                      </v-flex>

                      <v-flex xs12 sm4 class="col-padd">
                        <label class="tit-requerid">*</label><label
                          class="v-label mx-2 primary--text Label-primary">Periodicidad de medición</label>
                        <v-select dense v-validate="'required'" data-vv-name="idperiodicidadactualizacion"
                          :error-messages="errors.collect('idperiodicidadactualizacion')"
                          :readonly="readcontrol('idperiodicidadactualizacion') && !admineditar"
                          v-show="showcontrol('idperiodicidadactualizacion')"
                          v-model="valPunto.idperiodicidadactualizacion" :items="gperiodicidad" item-text="nombre"
                          item-value="idperiodicidad" outlined ref="idperiodicidadactualizacion"></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 class="col-padd">
                        <label class="tit-requerid">*</label><label
                          class="v-label mx-2 primary--text Label-primary">Días de rezago</label>
                        <v-text-field dense v-validate="'required|numeric'" data-vv-name="diasrezago"
                          :error-messages="errors.collect('diasrezago')"
                          :readonly="readcontrol('diasrezago') && !admineditar" v-show="showcontrol('diasrezago')"
                          v-model="valPunto.diasrezago" outlined :clearable="!readcontrol('diasrezago')"
                          ref="diasrezago"></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 class="col-padd">
                        <label class="tit-requerid">*</label><label
                          class="v-label mx-2 primary--text Label-primary">Fórmula de cálculo</label>
                        <v-textarea dense v-validate="'required|max:8000'" data-vv-name="formulacalculo"
                          :error-messages="errors.collect('formulacalculo')" :counter="2000"
                          :readonly="readcontrol('formulacalculo') && !admineditar"
                          v-show="showcontrol('formulacalculo')" v-model="valPunto.formulacalculo" outlined
                          :clearable="!readcontrol('formulacalculo')" ref="formulacalculo"></v-textarea>
                      </v-flex>

                      <v-flex xs12 sm12 class="col-padd">
                        <label class="tit-requerid">*</label><label
                          class="v-label mx-2 primary--text Label-primary">Fuentes de información</label>
                        <v-textarea dense v-validate="'required|max:4000'" data-vv-name="fuenteinformacion"
                          :error-messages="errors.collect('fuenteinformacion')" :counter="4000"
                          v-model="valPunto.fuenteinformacion" v-show="showcontrol('fuenteinformacion')" outlined
                          ref="fuenteinformacion"
                          :readonly="readcontrol('fuenteinformacion') && !admineditar"></v-textarea>
                      </v-flex>

                      <v-flex xs12 sm12 class="col-padd">
                        <label class="tit-requerid">*</label><label
                          class="v-label mx-2 primary--text Label-primary">Metodología de medición</label>
                        <v-textarea dense v-validate="'required|max:8000'" data-vv-name="metodologiamedicion"
                          :error-messages="errors.collect('metodologiamedicion')" :counter="8000"
                          :readonly="readcontrol('metodologiamedicion') && !admineditar"
                          v-show="showcontrol('metodologiamedicion')" v-model="valPunto.metodologiamedicion" outlined
                          :clearable="!readcontrol('metodologiamedicion')" ref="metodologiamedicion"></v-textarea>
                      </v-flex>

                      <v-flex xs12 sm12 class="col-padd" v-if="!finalizardeshabilitado()">
                        <v-flex v-if=" (elemento_coment>= 0 && gtareasbyelemento.idrol != undefined) && (gcomentarios.filter((p) => p.idcampo === 30).length > 0 || isUserDelegate == false)" >
                        <comentarios :tabla="tabla_coment" :elemento="elemento_coment" :campo="30" title="Comentarios" :lectura="isUserDelegate" :EsDelagado="isUserDelegate" :rolbyAccion="gtareasbyelemento.idrol" :idflujoaccion="gtareasbyelemento.idflujo" ></comentarios>
                      </v-flex>                        

                        <v-card flat :elevation="2" :loading="loading" :disabled="loading" outlined>
                          <v-card-text>
                            <v-flex xs12 sm12 class="col-padd" style="display: inline-flex; align-items: center;">
                              <v-switch v-model="tptieneavances"
                                :readonly="readcontrol('territorialindicador') && !admineditar"
                                class="v-label primary--text Label-primary"> </v-switch> <label
                                class="v-label mx-2 primary--text Label-primary">No aplica</label>
                            </v-flex>
                            <v-card :disabled="tptieneavances">
                              <v-flex xs12 sm12 class="col-padd" v-if="gindicador !== null">
                                <tipovalor_comp :getidindicador="gindicador.idindicador" :getcodigo="gindicador.codigo"
                                  :lectura="readcontrol('territorialindicador')"
                                  @conectMain="RecivetoChildrentipoValor">
                                </tipovalor_comp>
                              </v-flex>
                            </v-card>
                            <v-flex v-if="!finalizardeshabilitado()">
                            <v-flex v-if=" (elemento_coment>= 0 && gtareasbyelemento.idrol != undefined) && (gcomentarios.filter((p) => p.idcampo === 32).length > 0 || isUserDelegate == false)" >
                              <comentarios :tabla="tabla_coment" :elemento="elemento_coment" :campo="32" title="Comentarios"
                                :lectura="isUserDelegate" :EsDelagado="isUserDelegate" :rolbyAccion="gtareasbyelemento.idrol" :idflujoaccion="gtareasbyelemento.idflujo"></comentarios>
                            </v-flex>                          
                          </v-flex>
                          
                          
                          </v-card-text>
                        </v-card>
                      </v-flex>




                      <v-flex xs12 sm12 class="col-padd">

                        <v-card flat :elevation="2" :loading="loading" :disabled="loading" outlined>
                          <v-card-text>
                            <v-layout row wrap>

                              <v-flex xs12 sm12 class="col-padd" style="display: inline-flex; align-items: center;">
                                <v-switch v-model="tienelineabase" :readonly="readcontrol('lineabase') && !admineditar"
                                  class="v-label primary--text Label-primary" ref="LbaseSwitch" > </v-switch> <label
                                  class="v-label mx-2 primary--text Label-primary">Dispone de línea base</label>
                              </v-flex>

                              <v-flex xs12 sm12 class="col-padd">
                                <v-card :elevation="2" v-show="valPunto.tienelineabase">
                                  <v-card-text>
                                    <v-layout>
                                      <v-flex xs12 sm5></v-flex>

                                      <v-flex xs12 sm3>
                                        <label class="v-label mx-2 primary--text Label-primary">Línea base</label>
                                        <v-text-field dense :readonly="readcontrol('lineabase') && !admineditar"
                                          v-show="showcontrol('lineabase')" 
                                          v-validate="'decimal:2|required_if:LbaseSwitch,true'" 
                                          data-vv-name="lineabase" :error-messages="errors.collect('lineabase')"
                                          v-model="valPunto.lineabase" :clearable="!readcontrol('lineabase')" outlined
                                          ref="lineabase"></v-text-field>
                                      </v-flex>
                                      <v-flex xs12 sm4>
                                        <label class="v-label mx-2 primary--text Label-primary">Fecha línea base</label>
                                        <v-menu ref="menu1" v-model="menu" :close-on-content-click="false"
                                          :return-value.sync="valPunto.fechabase" transition="scale-transition" offset-y
                                          full-width min-width="290px">
                                          <template v-slot:activator="{ on }">
                                            <v-text-field dense v-show="showcontrol('fechabase')"
                                              v-model="valPunto.fechabase" prepend-icon="event" readonly v-on="on"
                                              outlined></v-text-field>
                                          </template>
                                          <v-date-picker v-model="valPunto.fechabase" no-title scrollable locale="es"
                                            :disabled="readcontrol('fechabase') && !admineditar">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="menu = false">Cancelar</v-btn>
                                            <v-btn text color="primary" readonly
                                              @click="$refs.menu1.save(valPunto.fechabase) ">OK</v-btn>
                                          </v-date-picker>
                                        </v-menu>
                                      </v-flex>
                                    </v-layout>
                                    <v-flex xs12 sm12>
                                      <label class="v-label mx-2 primary--text Label-primary">Descripción línea
                                        base</label>
                                      <v-textarea dense :readonly="readcontrol('fuentebase') && !admineditar"
                                        v-show="showcontrol('fuentebase')" v-model="valPunto.descripcionlienabase"
                                        v-validate="'required_if:LbaseSwitch,true'"
                                        :error-messages="errors.collect('descripcionlineabase')" data-vv-name="descripcionlineabase" 
                                        :clearable="!readcontrol('fuentebase')" :counter="500" outlined ref="descripcionlineabase"></v-textarea>
                                    </v-flex>
                                    <v-flex xs12 sm12>
                                      <label class="v-label mx-2 primary--text Label-primary">Fuente línea base</label>
                                      <v-textarea dense :readonly="readcontrol('fuentebase') && !admineditar"
                                        v-validate="'required_if:LbaseSwitch,true'" 
                                        data-vv-name="fuentelineabase" :error-messages="errors.collect('fuentelineabase')"
                                        v-show="showcontrol('fuentebase')" v-model="valPunto.fuentebase"
                                        :clearable="!readcontrol('fuentebase')" :counter="1000" outlined ref="fuentelineabase"></v-textarea>
                                    </v-flex>
                                  </v-card-text>
                                </v-card>
                              </v-flex>

                              <v-flex xs12 sm12 class="col-padd">
                                <label v-show="!valPunto.tienelineabase"
                                  class="v-label mx-2 primary--text Label-primary">Argumento de por qué no tiene línea
                                  base </label>
                                <v-textarea dense v-show="!valPunto.tienelineabase"
                                  :readonly="readcontrol('lineabase') && !admineditar"
                                  v-validate="'required_if:LbaseSwitch,false,null,0,undefined,'" 
                                  data-vv-name="argumentonolineabase" :error-messages="errors.collect('argumentonolineabase')"
                                  v-model="valPunto.comentariolineabase" :clearable="!readcontrol('lineabase')"
                                  :counter="2000" outlined ref="argumentonolineabase"></v-textarea>
                              </v-flex>


                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-flex>

                      <v-flex xs12 sm4 class="col-padd">
                        <label class="tit-requerid">*</label> <label
                          class="v-label mx-2 primary--text Label-primary">Tipo acumulación</label>
                        <v-select dense :readonly="readcontrol('idtipoacumulacion') && !admineditar"
                          v-show="showcontrol('idtipoacumulacion')" :items="TAcumulacion"
                          v-model="valPunto.idtipoacumulacion" item-text="nombre" item-value="idtipoacumulacion"
                          v-validate="'required'" data-vv-name="idtipoacumulacion"
                          :error-messages="errors.collect('idtipoacumulacion')" outlined @change="ChangeTipoAcumulacion"
                          lineabase ref="idtipoacumulacion"></v-select>
                      </v-flex>

                      <v-flex xs12 sm8 class="col-padd" v-if="DescripcionAcumulacion.length > 0">
                        <label class="tit-requerid">*</label> <label
                          class="v-label mx-2 primary--text Label-primary">Definición de tipo de acumulación</label>
                        <v-textarea dense :readonly="true" v-model="DescripcionAcumulacion" rows="1"
                          class="field-disabled mx-2" outlined></v-textarea>
                      </v-flex>

                      <v-flex xs12 sm4 class="col-padd">
                        <label class="tit-requerid">*</label> <label class="v-label mx-2 primary--text Label-primary">
                          Orientación del indicador </label>
                        <v-select dense :readonly="true" v-show="showcontrol('idtipoacumulacion')" :items="gorientacion"
                          v-model="valPunto.idorientacion" item-text="nombre" item-value="idorientacion"
                          v-validate="'required'" data-vv-name="idorientacion" class="field-disabled"
                          :error-messages="errors.collect('idorientacion')" outlined ref="idorientacion"></v-select>
                      </v-flex>

                      <v-flex xs12 sm2 class="col-padd">
                        <v-switch dense compact density="compact" v-model="tieneseriehistorica" :readonly="readcontrol('lineabase')"
                                  > </v-switch> <label
                                  class="v-label fs-8">Dispone de serie histórica</label>
                      </v-flex>

                      <v-flex xs12 sm6 class="col-padd" >

                        <!-- año inicio 2016 año fin año menor al año actual -->
                        <label class="v-label primary--text Label-primary">Año o serie disponible</label>
                        <!-- <v-text-field dense v-model="valPunto.seriedisponible" outlined></v-text-field> -->
                         <v-card :disabled="readcontrol('lineabase')">
                          <v-card :loading="LoadingSeries" :disabled="LoadingSeries" :elevation="0" >
                            <v-range-slider :disabled="!tieneseriehistorica" v-model="rangeyears" :max="rangeslidermax" :min="rangeslidermin" :step="1" class="align-center" hide-details outlined >
                              <template v-slot:prepend>
                                <v-text-field v-model="valPunto.serieinicio" dense  style="width: 80px" type="number" outlined hide-details single-line ></v-text-field>
                              </template>
                              <template v-slot:append>
                                <v-text-field v-model="valPunto.seriefin" dense  style="width: 80px" type="number" outlined hide-details single-line ></v-text-field>
                              </template>
                            </v-range-slider>
                          </v-card>
                      </v-card>
                      </v-flex>
                      <v-flex v-if="gseries.length > 0 && tieneseriehistorica" xs12 sm12 class="col-padd" >
                        <v-card :disabled="readcontrol('lineabase')">
                        <serie_historica ref="serieComp" :anoInicio = "parseInt(rangeyears[0])" :anoFin = "parseInt(rangeyears[1])" :indicadorserie = "valPunto.idindicador" :Loading = "loading" ></serie_historica>
                      </v-card>
                      </v-flex>


                    </v-layout>
                  </v-card-text>
                </v-card>
                <br>


                <v-card flat :elevation="2" :loading="loading" :disabled="loading" outlined>
                  <v-card-text>
                    <v-flex xs12 sm12 class="col-padd">
                      <label class="tit-requerid">*</label><label
                        class="v-label mx-2 primary--text Label-primary">Información de metas</label>
                      <v-divider class="field-divider"
                        style="border: dotted; border-width: 1px; border-color: #d1cdcd;"></v-divider>

                    </v-flex>
                    <v-form>
                      </br>
                      <v-layout row wrap>
                        <v-flex xs12 sm5 class="col-padd">
                          <v-data-table dense :headers="headerMetasFilter" v-show="showcontrol('metasvigencia')"
                            :items="MetasVigencia" class="elevation-1" :no-data-text="gnodata" :items-per-page="20" :item-class= "row_classes" 
                            item-key="idmeta">
                            <template v-slot:top>
                              <v-dialog v-model="dialogMeta" max-width="220px">
                                <v-card>
                                  <v-card-text>
                                    <br>
                                    <v-flex xs12 sm12 md12>
                                      <label class="v-label mx-2">Meta</label>
                                      <v-text-field v-model="editedItemMeta.metaTmp" v-validate="'decimal:2'"
                                        data-vv-name="MetasVigencia" :error-messages="errors.collect('MetasVigencia')"
                                        outlined></v-text-field>
                                    </v-flex>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-btn color="blue darken-1" @click="close">Cancelar</v-btn>
                                    <v-btn color="blue darken-1" @click="saveMetaVigencia">Guardar</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-icon v-on="on" small :disabled="!((admineditar && !item.editable) || (!readcontrol('metasvigencia') && item.editable && !admineditar) )
                                        " class="mr-2" @click="editItemMetaVigencia(item)">edit</v-icon>
                                </template>
                                <span>Editar</span>
                              </v-tooltip>

                              <v-tooltip top v-if="currentRol.findIndex(x => x == 1) !== -1">
                                <template v-slot:activator="{ on }">
                                  <v-icon small v-on="on" @click="editEstadoMeta(item)"
                                    class="mr-2">fa-check-circle</v-icon>
                                </template>
                                <span>{{ item.idestadoNavigation.nombre }}</span>
                              </v-tooltip>
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-icon v-on="on" v-if="verauditoria()" small class="mr-2"
                                    @click="VerAuditoriaRegistro(item)">fa-glasses</v-icon>
                                </template>
                                <span>Ver auditoría</span>
                              </v-tooltip>
                            </template>
                            <template v-slot:[`item.metaTmp`]="{ item }">
                              <div v-if="item.valor !=  item.metaTmp">
                                  {{ item.metaTmp }}
                              </div>
                            </template>                            
                          </v-data-table>
                        </v-flex>
                        <v-flex xs12 sm5 class="col-padd">
                          <v-data-table dense v-show="showcontrol('metascuatrenio')" :headers="headerMetasCuatrFilter"
                            :items="MetasCuatrenio" class="elevation-1" :no-data-text="gnodata" :items-per-page="10" :item-class= "row_classes"
                            item-key="idmeta">
                            <template v-slot:[`item.metaTmp`]="{ item }">
                              <div v-if="item.valor !=  item.metaTmp">
                                  {{ item.metaTmp }}
                              </div>
                            </template>
                          </v-data-table>
                        </v-flex>
                        <v-flex xs12 sm2 class="col-padd">
                          <label class="v-label mx-2 primary--text Label-primary">Meta global</label>
                          <v-text-field dense readonly v-show="showcontrol('meta')" v-model="valPunto.meta"
                            :clearable="!readcontrol('meta')" v-validate="'decimal:2'" data-vv-name="Metas"
                            :error-messages="errors.collect('Metas')" outlined> </v-text-field>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn class="ma-2" v-on="on" block color="blue-grey lighten-3" @click="RefrescarMetas" :disabled="readcontrol('BottonMetas')">
                                <v-icon left>fa-sync-alt</v-icon>Generar metas
                                <span></span>
                              </v-btn>
                            </template>
                            <span>
                              Es necesario escoger el tipo de acumulación. Calcula
                              solo las metas de los periodos y la meta global (no
                              las anuales). Para capacidad incluya la línea base en
                              el cálculo de la meta
                            </span>
                          </v-tooltip>

                          <!-- <v-alert dense text colored-border elevation="2" border="left" color="info"
                            :value="readcontrol('reporte')" >
                            <v-flex xs12 sm12>
                              La función de generar metas estará disponible en Emisión CTU del validador.
                            </v-flex>
                          </v-alert> -->

                        </v-flex>


                        <v-flex xs12 sm12 class="col-padd" v-if="MetasVigenciaext.length > 0">
                          </br>
                          <label class="v-label mx-2 primary--text Label-primary">Avance rezagado o posterior a la
                            vigencia PMI</label>
                          <v-divider class="field-divider"
                            style="border: dotted; border-width: 1px; border-color: #d1cdcd;"></v-divider>
                          </br>
                        </v-flex>

                        <v-flex xs12 sm5 class="col-padd" v-if="MetasVigenciaext.length > 0">
                          <v-data-table dense :headers="HeaderMetasVigencia" v-show="showcontrol('metasvigencia')"
                            :items="MetasVigenciaext" class="elevation-1" :no-data-text="gnodata" :items-per-page="20"
                            item-key="idmeta">
                            <template v-slot:top>
                              <v-dialog v-model="dialogMetaext" max-width="220px">
                                <v-card>
                                  <v-card-text>
                                    <br>
                                    <v-flex xs12 sm12 md12>
                                      <v-text-field v-model="editedItemMeta.valor" label="Meta" v-validate="'decimal:2'"
                                        data-vv-name="MetasVigencia" :error-messages="errors.collect('MetasVigencia')"></v-text-field>
                                    </v-flex>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-btn color="blue darken-1" @click="close">Cancelar</v-btn>
                                    <v-btn color="blue darken-1" @click="saveMetaVigenciaExt">Guardar</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-icon v-on="on" v-if="verauditoria()" small class="mr-2"
                                    @click="VerAuditoriaRegistro(item)">fa-glasses</v-icon>
                                </template>
                                <span>Ver auditoría</span>
                              </v-tooltip>
                            </template>
                            <template v-slot:[`item.metaTmp`]="{ item }">
                              <div v-if="item.valor !=  item.metaTmp">
                                  {{ item.metaTmp }}
                              </div>
                            </template>                            
                          </v-data-table>
                        </v-flex>
                        <v-flex xs12 sm5 class="col-padd" v-if="MetasVigenciaext.length > 0">
                          <v-data-table dense v-show="showcontrol('metascuatrenio')" :headers="HeaderMetasCuatrenio"
                            :items="MetasCuatrenioext" class="elevation-1" :no-data-text="gnodata" :items-per-page="10"
                            item-key="idmeta"></v-data-table>
                        </v-flex>
                        <v-flex xs12 sm2 class="col-padd" v-if="MetasVigenciaext.length > 0">
                        </v-flex>
                        </br>
                        <v-flex xs12 sm6 class="col-padd">
                          <label class="tit-requerid">*</label><label
                            class="v-label mx-2 primary--text Label-primary">Metodología para proyección de
                            metas</label>
                          <v-select dense v-validate="'required'" data-vv-name="idmetodologia"
                            :error-messages="errors.collect('idmetodologia')"
                            :readonly="readcontrol('idperiodicidadactualizacion')" v-model="valPunto.idmetodologia"
                            :items="gmetodologias" item-text="nombre" item-value="idmetodologia" outlined
                            :clearable="!readcontrol('idperiodicidadactualizacion')" ref="idmetodologia"></v-select>
                        </v-flex>

                        <v-flex xs12 sm6 class="col-padd" v-if="valPunto.idmetodologia == 9">
                          <label class="tit-requerid">*</label><label
                            class="v-label mx-2 primary--text Label-primary">Otra Metodología</label>
                          <v-text-field dense v-validate="'required'" data-vv-name="otraMetedologiaPM"
                            :error-messages="errors.collect('otraMetedologiaPM')"
                            :readonly="readcontrol('idperiodicidadactualizacion')"
                            v-show="showcontrol('idperiodicidadactualizacion')" v-model="valPunto.otraMetedologiaPM"
                            outlined :clearable="!readcontrol('idperiodicidadactualizacion')" ref="otraMetedologiaPM"
                            :counter="500"></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 class="col-padd" v-if="gmetodologias.filter((p) => p.idmetodologia == valPunto.idmetodologia).length > 0">
                          <label class="v-label mx-2 primary--text Label-primary">Metodología</label>
                          <v-textarea dense :readonly="true" rows="1" class="field-disabled mx-2"
                            v-model="gmetodologias.filter((p) => p.idmetodologia == valPunto.idmetodologia)[0].descripcion"
                            outlined>
                          </v-textarea>
                        </v-flex>

                        <v-flex xs12 sm12 class="col-padd">
                          <label class="tit-requerid">*</label><label
                            class="v-label mx-2 primary--text Label-primary">Descripción de la metodología de medición</label>
                          <v-textarea dense :readonly="readcontrol('idperiodicidadactualizacion') "
                            v-validate="'required'" data-vv-name="descripcionmetodologia"
                            :error-messages="errors.collect('descripcionmetodologia')"
                            v-model="valPunto.descripcionmetodologia"
                            :clearable="!readcontrol('descripcionmetodologia')" :counter="400" outlined
                            ref="descripcionmetodologia">
                          </v-textarea>
                        </v-flex>

                        <v-flex xs12 class="col-padd">
                          <v-card :elevation="2" v-show="false">
                            <v-card-text>
                              <v-layout row wrap>
                                <v-flex xs12 sm4 md4 v-show="showcontrol('territorialindicador')">
                                  Territorialización de indicador *
                                  <v-radio-group data-vv-name="Radioterritorialindicador"
                                    :error-messages="errors.collect('Radioterritorialindicador') " row
                                    v-model="switchTerritorio"
                                    :readonly="readcontrol('territorialindicador') && !admineditar"
                                    ref="Radioterritorialindicador">
                                    <v-radio label="Si" :value="true"></v-radio>
                                    <v-radio label="No" :value="false"></v-radio>
                                  </v-radio-group>
                                </v-flex>
                                <v-flex xs12 sm4 md4 v-show="showcontrol('desagregacionpoblacional')">
                                  Desagregación poblacional por sexo *
                                  <v-radio-group row data-vv-name="Radiodesagregacion"
                                    :error-messages="errors.collect('Radiodesagregacion')"
                                    v-model="valPunto.desagregacionpoblacional"
                                    :readonly="readcontrol('desagregacionpoblacional') && !admineditar ">
                                    <v-radio label="Si" :value="true"></v-radio>
                                    <v-radio label="No" :value="false"></v-radio>
                                  </v-radio-group>
                                </v-flex>
                                <v-flex xs12 sm4 md4 v-show="showcontrol('pertenenciaetnica')">
                                  Pertenencia étnica *
                                  <v-radio-group row data-vv-name="RadioPertenencia"
                                    :error-messages="errors.collect('RadioPertenencia') "
                                    v-model="valPunto.pertenenciaetnica"
                                    :readonly="readcontrol('pertenenciaetnica') && !admineditar ">
                                    <v-radio label="Si" :value="true"></v-radio>
                                    <v-radio label="No" :value="false"></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                            </v-card-text>

                            <v-card color="#EEEEEE" v-show="valPunto.territorialindicador">
                              <v-card-text>
                                <v-label>Nivel de desagregación - solo si territorialización fue positivo</v-label>

                                <v-flex xs12 sm12>
                                  <v-select v-show="showcontrol('niveldesagregacion')"
                                    :readonly="readcontrol('niveldesagregacion') && !admineditar "
                                    :items="gterritorializaciones" v-model="territorializacionselect" item-text="nombre"
                                    item-value="idterritorializacion" label="Territorialización" multiple></v-select>
                                </v-flex>
                              </v-card-text>
                            </v-card>
                          </v-card>
                        </v-flex>


                        <v-flex xs12 sm6 class="col-padd">

                        </v-flex>

                        <v-flex xs12 sm6 class="col-padd">

                        </v-flex>

                        <v-flex xs12 sm12 class="col-padd">
                          <label class="v-label mx-2 primary--text Label-primary">Observaciones</label>
                          <v-textarea dense data-vv-name="observacionadicional" v-model="valPunto.observacionadicional"
                            :clearable="false" v-show="showcontrol('observacionadicional')"
                            :readonly="readcontrol('observacionadicional') && !admineditar" outlined
                            :counter="1000"></v-textarea>
                        </v-flex>

                        <v-flex xs12 sm12 class="col-padd">
                          <label v-show="clasificacionetnico" class="tit-requerid">*</label> <label
                            v-show="clasificacionetnico" class="v-label mx-2 primary--text Label-primary">Metas
                            trazadoras</label>
                          <v-textarea dense data-vv-name="metastrazadorasobs" v-model="valPunto.metastrazadoras"
                            v-show="clasificacionetnico" :readonly="!admineditar" class="field-disabled"
                            outlined></v-textarea>
                        </v-flex>

                        <v-flex xs12 sm12 class="col-padd">
                          <label v-show="clasificacionetnico" class="tit-requerid">*</label> <label
                            v-show="clasificacionetnico" class="v-label mx-2 primary--text Label-primary">Observaciones
                            étnicas </label>
                          <v-textarea dense data-vv-name="observacionetnicosobs" v-model="valPunto.observacionetnicos"
                            v-show="clasificacionetnico" :readonly="!admineditar" class="field-disabled"
                            outlined></v-textarea>
                        </v-flex>


                        <v-flex xs12 sm12 v-show="showcontrol('requierehito')" class="col-padd">
                          <label class="tit-requerid">*</label> <label
                            class="v-label mx-2 primary--text Label-primary">¿Este indicador requiere hitos? </label>
                          <v-radio-group dense row v-model="switchrequierehito"
                            :readonly="readcontrol('requierehito') && !admineditar">
                            <v-radio label="Si" :value="true"></v-radio>
                            <v-radio label="No" :value="false"></v-radio>
                          </v-radio-group>
                        </v-flex>

                        <v-flex xs12 sm12>

                          <v-card flat :elevation="2" :loading="loading" :disabled="loading"
                            v-show="valPunto.requierehito" outlined>
                            <v-card-title>
                              Lista de Hitos
                            </v-card-title>
                            <v-card-text>
                              <v-flex xs12 sm12>
                                <v-data-table :headers="HeaderHitos" :items="Hitos" :items-per-page="100"
                                  class="elevation-1" hide-default-footer :no-data-text="gnodata" :sort-by="sortBy"
                                  :sort-desc="sortDesc">
                                  <template v-slot:top>
                                    <v-toolbar color="white">
                                      <v-toolbar-title>Hitos</v-toolbar-title>
                                      <v-divider class="mx-4" inset vertical></v-divider>
                                      <v-spacer></v-spacer>
                                      <v-dialog v-model="dialog" max-width="500px">
                                        <template v-slot:activator="{ on: dialog }">
                                          <v-tooltip top>
                                            <template v-slot:activator="{ on: tooltip }">
                                              <v-btn color="primary" :disabled="readcontrol('requierehito') && !admineditar
                                              " v-on="{ ...tooltip, ...dialog }">
                                                <v-icon>add</v-icon>
                                              </v-btn>
                                            </template>
                                            <span>Agregar</span>
                                          </v-tooltip>
                                        </template>
                                        <v-card>
                                          <v-card-title>Detalle del hito</v-card-title>
                                          <v-card-text>
                                            <v-container grid-list-md v-if="editedItem != null">
                                              <v-layout wrap>
                                                <v-flex xs12 sm12 md12>
                                                  <v-textarea v-validate="'max:2000'" data-vv-name="descripcionhito"
                                                    :error-messages="errors.collect('descripcionhito')
                                                    " :counter="2000" v-model="editedItem.descripcion"
                                                    label="Descripción"></v-textarea>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                  <v-text-field v-validate="'required'" data-vv-name="ponderacionhito"
                                                    :error-messages="errors.collect('ponderacionhito')
                                                    " v-model="editedItem.ponderacion" label="Ponderación"
                                                    type="number" min="1" max="100"></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 sm6 md6>
                                                  <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                                                    :return-value.sync="editedItem.fechacumplimiento
                                                    " transition="scale-transition" offset-y full-width
                                                    min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                      <v-text-field v-model="editedItem.fechacumplimiento"
                                                        label="Fecha cumplimiento" prepend-icon="event" readonly
                                                        v-on="on"></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="editedItem.fechacumplimiento" no-title
                                                      scrollable locale="es">
                                                      <v-spacer></v-spacer>
                                                      <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                                                      <v-btn text color="primary" @click="
                                                      $refs.menu2.save(
                                                        editedItem.fechacumplimiento
                                                      )
                                                      ">OK</v-btn>
                                                    </v-date-picker>
                                                  </v-menu>
                                                </v-flex>
                                              </v-layout>
                                            </v-container>
                                          </v-card-text>
                                          <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" @click="close">Cancelar</v-btn>
                                            <v-btn color="blue darken-1" @click="save">Guardar</v-btn>
                                          </v-card-actions>
                                        </v-card>
                                      </v-dialog>
                                    </v-toolbar>
                                  </template>
                                  <template v-slot:[`item.action`]="{ item }">
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on }">
                                        <v-icon small v-on="on" class="mr-2" @click="editItem(item)" :disabled="readcontrol('requierehito') && !admineditar
                                        ">edit</v-icon>
                                      </template>
                                      <span>Editar</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on }">
                                        <v-icon small v-on="on" @click="deleteItem(item)" :disabled="readcontrol('requierehito') && !admineditar
                                        ">delete</v-icon>
                                      </template>
                                      <span>Eliminar</span>
                                    </v-tooltip>
                                  </template>
                                </v-data-table>
                              </v-flex>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                        <v-flex v-if="!finalizardeshabilitado()">
                        <v-flex v-if=" (elemento_coment>= 0 && gtareasbyelemento.idrol != undefined) && (gcomentarios.filter((p) => p.idcampo === 33).length > 0 || isUserDelegate == false)" >
                          <comentarios :tabla="tabla_coment" :elemento="elemento_coment" :campo="33" title="Comentarios"
                            :lectura="isUserDelegate" :EsDelagado="isUserDelegate" :rolbyAccion="gtareasbyelemento.idrol" :idflujoaccion="gtareasbyelemento.idflujo"></comentarios>
                        </v-flex>
                      </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                </v-card>


                <br>
                <v-card flat :elevation="2" :loading="loading" :disabled="loading" outlined v-show="false">
                  <v-card-title>
                    4. Información de responsables
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>

                      <v-flex xs12 sm6 class="col-padd">
                        <v-dialog v-model="dialogasignargerente" width="900" persistent>
                          <v-tabs show-arrows next-icon="fa-caret-right" prev-icon="fa-caret-left"
                            background-color="blue-grey lighten-4" horizontal>
                            <v-tab> <v-icon left>search</v-icon>Buscar Gerente </v-tab>
                            <v-tab> <v-icon left>add</v-icon>Crear Gerente </v-tab>
                            <v-tab-item>
                              <v-card>
                                <v-card-text>
                                  <label class="v-label mx-2 primary--text Label-primary">Buscar gerente </label>
                                  <v-autocomplete dense :items="gpersonas" v-model="valPunto.idpersonagerentebuscar"
                                    v-on:change="changepersonagerentebuscar" item-text="nombre" item-value="idpersona"
                                    class="mx-2" :readonly="readcontrol('idpersonagerente') && !admineditar" outlined>
                                  </v-autocomplete>
                                  <v-divider></v-divider>
                                  <v-card :disabled="editablegerente">
                                    <v-card-text>
                                      <v-layout row wrap>
                                        <v-flex xs12 sm6>
                                          <label class="v-label mx-2 primary--text Label-primary">Nombre </label>
                                          <v-text-field class="mx-2 field-disabled" dense
                                            v-model="personagerentebuscar.nombre" data-vv-name="nombregerente"
                                            outlined></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                          <label class="v-label mx-2 primary--text Label-primary">Cargo </label>
                                          <v-text-field class="mx-2 field-disabled" dense
                                            v-model="personagerentebuscar.cargo" data-vv-name="cargogerente"
                                            outlined></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                          <label class="v-label mx-2 primary--text Label-primary">Entidad </label>
                                          <v-autocomplete class="mx-2 field-disabled" dense
                                            v-model="personagerentebuscar.identidad" :items="Entidades"
                                            item-text="nombre" item-value="identidad" data-vv-name="entidadGerente"
                                            outlined></v-autocomplete>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                          <label class="v-label mx-2 primary--text Label-primary">Dependencia </label>
                                          <v-text-field class="mx-2 field-disabled" dense
                                            v-model="personagerentebuscar.dependencia" clearable
                                            outlined></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                          <label class="v-label mx-2 primary--text Label-primary">Correo Electrónico
                                          </label>
                                          <v-text-field class="mx-2 field-disabled" dense
                                            v-model="personagerentebuscar.correo" data-vv-name="correogerente"
                                            outlined></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-text>
                                  </v-card>
                                </v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn class="text-white" color="blue darken-1"
                                    @click="dialogasignargerente = false">Cancelar</v-btn>
                                  <v-btn class="text-white" color="blue darken-1"
                                    @click="asignargerente">Asignar</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item>
                              <v-form ref="formnewgerente">
                                <v-card>
                                  <v-card-text>
                                    <v-layout row wrap>
                                      <v-flex xs12 sm6>
                                        <label class="tit-requerid">*</label><label
                                          class="v-label mx-2 primary--text Label-primary">Nombre </label>
                                        <v-text-field class="mx-2" v-model="newpersonagerente.nombre" clearable outlined
                                          dense v-validate="'required|max:100'" data-vv-name="newnombregerente"
                                          data-vv-scope="newgerente"
                                          :error-messages="errors.collect('newnombregerente', 'newgerente')  "
                                          :counter="100"></v-text-field>
                                      </v-flex>
                                      <v-flex xs12 sm6>
                                        <label class="tit-requerid">*</label><label
                                          class="v-label mx-2 primary--text Label-primary">Cargo </label>
                                        <v-text-field class="mx-2" v-model="newpersonagerente.cargo" clearable outlined
                                          dense v-validate="'required|max:100'" data-vv-name="newcargogerente"
                                          data-vv-scope="newgerente"
                                          :error-messages="errors.collect('newcargogerente', 'newgerente') "
                                          :counter="100"></v-text-field>
                                      </v-flex>
                                      <v-flex xs12 sm6>
                                        <label class="tit-requerid">*</label><label
                                          class="v-label mx-2 primary--text Label-primary">Entidad </label>
                                        <v-autocomplete class="mx-2" v-model="newpersonagerente.identidad"
                                          :items="Entidades" outlined dense item-text="nombre" item-value="identidad"
                                          v-validate="'required'" data-vv-name="newentidadgerente"
                                          data-vv-scope="newgerente"
                                          :error-messages="errors.collect('newentidadgerente', 'newgerente') "></v-autocomplete>
                                      </v-flex>
                                      <v-flex xs12 sm6>
                                        <label class="tit-requerid">*</label><label
                                          class="v-label mx-2 primary--text Label-primary">Dependencia </label>
                                        <v-text-field class="mx-2" v-model="newpersonagerente.dependencia" clearable
                                          outlined dense></v-text-field>
                                      </v-flex>
                                      <v-flex xs12 sm6>
                                        <label class="tit-requerid">*</label><label
                                          class="v-label mx-2 primary--text Label-primary">Correo Electrónico </label>
                                        <v-text-field class="mx-2" v-model="newpersonagerente.correo" clearable outlined
                                          dense v-validate="'required|email'" data-vv-name="newcorreogerente"
                                          data-vv-scope="newgerente"
                                          :error-messages="errors.collect('newcorreogerente', 'newgerente') "></v-text-field>
                                      </v-flex>
                                    </v-layout>
                                  </v-card-text>

                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn class="text-white" color="blue darken-1"
                                      @click="dialogasignargerente = false">Cancelar</v-btn>
                                    <v-btn class="text-white" color="blue darken-1"
                                      @click="guardargerente">Guardar</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-form>
                            </v-tab-item>
                          </v-tabs>
                        </v-dialog>

                        <v-expansion-panels :accordion="false" :inset="true" :focusable="true"
                          v-show="showcontrol('idpersonagerente')">
                          <v-expansion-panel>
                            <v-expansion-panel-header disable-icon-rotate>
                              <v-app-bar-nav-icon></v-app-bar-nav-icon>
                              <v-toolbar-title>Gerente de meta</v-toolbar-title>
                              <template v-slot:actions>
                                <v-icon color="teal">info</v-icon>
                              </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-app-bar>
                                <v-autocomplete :items="gpersonas" v-model="valPunto.idpersonagerente"
                                  v-on:change="changepersonagerente" item-text="nombre" item-value="idpersona"
                                  label="Buscar gerente:" :readonly="true">
                                  <template v-slot:append-outer>
                                    <v-slide-x-reverse-transition mode="out-in">
                                      <v-icon :color="colorGerenteMeta" @click="dialogasignargerente = true"
                                        :disabled="readcontrol('idpersonagerente') && !admineditar">mdi-database-search</v-icon>
                                    </v-slide-x-reverse-transition>
                                  </template>
                                </v-autocomplete>
                              </v-app-bar>
                              <v-divider></v-divider>
                              <v-card :disabled="editablegerente">
                                <v-card-text>
                                  <label class="v-label mx-2 primary--text Label-primary">Nombre </label>
                                  <v-text-field v-model="personagerente.nombre" data-vv-name="nombregerente" outlined
                                    dense></v-text-field>

                                  <label class="v-label mx-2 primary--text Label-primary">Cargo </label>
                                  <v-text-field v-model="personagerente.cargo" data-vv-name="cargogerente" outlined
                                    dense></v-text-field>

                                  <label class="v-label mx-2 primary--text Label-primary">Entidad</label>
                                  <v-autocomplete v-model="personagerente.identidad" :items="Entidades"
                                    item-text="nombre" item-value="identidad" data-vv-name="entidadGerente" outlined
                                    dense></v-autocomplete>

                                  <label class="v-label mx-2 primary--text Label-primary">Dependencia</label>
                                  <v-text-field v-model="personagerente.dependencia" outlined dense></v-text-field>

                                  <label class="v-label mx-2 primary--text Label-primary">Correo Electrónico</label>
                                  <v-text-field v-model="personagerente.correo" data-vv-name="correogerente" outlined
                                    dense></v-text-field>
                                </v-card-text>
                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-flex>

                      <v-flex xs12 sm6 class="col-padd">
                        <v-dialog v-model="dialogasignaraprobador" width="900" persistent>
                          <v-tabs show-arrows next-icon="fa-caret-right" prev-icon="fa-caret-left"
                            background-color="blue-grey lighten-4" horizontal>
                            <v-tab> <v-icon left>search</v-icon>Buscar Aprobador </v-tab>
                            <v-tab> <v-icon left>add</v-icon>Crear Aprobador </v-tab>
                            <v-tab-item>
                              <v-card>
                                <v-card-text>
                                  <v-autocomplete :items="gpersonas" v-model="valPunto.idpersonaaprobadorbuscar"
                                    v-on:change="chagepersonaaprobadorbuscar" item-text="nombre" item-value="idpersona"
                                    label="Buscar aprobador:"
                                    :readonly="readcontrol('idpersonaaprobador') && !admineditar">

                                  </v-autocomplete>
                                  <v-divider></v-divider>
                                  <v-card :disabled="editableaprobador">
                                    <v-card-text>
                                      <v-layout row wrap>
                                        <v-flex xs12 sm6>
                                          <label class="v-label mx-2 primary--text Label-primary">Nombre</label>
                                          <v-text-field class="mx-2 field-disabled"
                                            v-model="personaaprobadorbuscar.nombre" outlined dense></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                          <label class="v-label mx-2 primary--text Label-primary">Cargo</label>
                                          <v-text-field class="mx-2 field-disabled"
                                            v-model="personaaprobadorbuscar.cargo" outlined dense></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm6>
                                          <label class="v-label mx-2 primary--text Label-primary">Entidad</label>
                                          <v-autocomplete class="mx-2 field-disabled"
                                            v-model="personaaprobadorbuscar.identidad" :items="Entidades"
                                            item-text="nombre" item-value="identidad" outlined dense></v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 sm6>
                                          <label class="v-label mx-2 primary--text Label-primary">Dependencia</label>
                                          <v-text-field class="mx-2 field-disabled"
                                            v-model="personaaprobadorbuscar.dependencia" outlined dense></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm6>
                                          <label class="v-label mx-2 primary--text Label-primary">Correo
                                            Electrónico</label>
                                          <v-text-field class="mx-2 field-disabled"
                                            v-model="personaaprobadorbuscar.correo" outlined dense></v-text-field>
                                        </v-flex>

                                      </v-layout>
                                    </v-card-text>
                                  </v-card>
                                </v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn class="text-white" color="blue darken-1"
                                    @click="dialogasignaraprobador = false">Cancelar</v-btn>
                                  <v-btn class="text-white" color="blue darken-1"
                                    @click="asignaraprobador">Asignar</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item>
                              <v-card>
                                <v-form ref="formnewaprobador">
                                  <v-card-text>
                                    <v-layout row wrap>
                                      <v-flex xs12 sm6>
                                        <label class="tit-requerid">*</label><label
                                          class="v-label mx-2 primary--text Label-primary">Nombre </label>
                                        <v-text-field class="mx-2" outlined dense v-model="newpersonaaprobador.nombre"
                                          clearable v-validate="'required|max:100'" data-vv-name="newnombreaprobador"
                                          data-vv-scope="newaprobador"
                                          :error-messages="errors.collect('newnombreaprobador', 'newaprobador') "
                                          :counter="100"></v-text-field>
                                      </v-flex>

                                      <v-flex xs12 sm6>
                                        <label class="tit-requerid">*</label><label
                                          class="v-label mx-2 primary--text Label-primary">Cargo </label>
                                        <v-text-field class="mx-2" outlined dense v-model="newpersonaaprobador.cargo"
                                          clearable v-validate="'required|max:100'" data-vv-name="newcargoaprobador"
                                          data-vv-scope="newaprobador"
                                          :error-messages="errors.collect('newcargoaprobador', 'newaprobador') "
                                          :counter="100"></v-text-field>
                                      </v-flex>

                                      <v-flex xs12 sm6>
                                        <label class="tit-requerid">*</label><label
                                          class="v-label mx-2 primary--text Label-primary">Entidad </label>
                                        <v-autocomplete class="mx-2" outlined dense
                                          v-model="newpersonaaprobador.identidad" :items="Entidades" item-text="nombre"
                                          item-value="identidad" v-validate="'required'"
                                          data-vv-name="newentidadaprobador" data-vv-scope="newaprobador"
                                          :error-messages="errors.collect('newentidadaprobador', 'newaprobador')"></v-autocomplete>
                                      </v-flex>

                                      <v-flex xs12 sm6>
                                        <label class="tit-requerid">*</label><label
                                          class="v-label mx-2 primary--text Label-primary">Dependencia </label>
                                        <v-text-field class="mx-2" outlined dense
                                          v-model="newpersonaaprobador.dependencia" clearable
                                          v-validate="'required|max:100'" data-vv-name="newdependenciaaprobador"
                                          data-vv-scope="newaprobador"
                                          :error-messages="errors.collect('newdependenciaaprobador', 'newaprobador') "></v-text-field>
                                      </v-flex>
                                      <v-flex xs12 sm6>
                                        <label class="tit-requerid">*</label><label
                                          class="v-label mx-2 primary--text Label-primary">Correo Electrónico </label>
                                        <v-text-field class="mx-2" outlined dense v-model="newpersonaaprobador.correo"
                                          clearable v-validate="'required|email'" data-vv-name="newcorreoaprobador"
                                          data-vv-scope="newaprobador"
                                          :error-messages="errors.collect('newcorreoaprobador', 'newaprobador') "></v-text-field>
                                      </v-flex>
                                    </v-layout>
                                  </v-card-text>

                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn class="text-white" color="blue darken-1"
                                      @click="dialogasignaraprobador = false">Cancelar</v-btn>
                                    <v-btn class="text-white" color="blue darken-1"
                                      @click="guardaraprobador">Guardar</v-btn>
                                  </v-card-actions>
                                </v-form>
                              </v-card>
                            </v-tab-item>
                          </v-tabs>
                        </v-dialog>
                        <v-expansion-panels :accordion="false" :inset="true" :focusable="true"
                          v-show="showcontrol('idpersonaaprobador')">
                          <v-expansion-panel>
                            <v-expansion-panel-header disable-icon-rotate>
                              <v-app-bar-nav-icon class="mx-2"></v-app-bar-nav-icon>
                              <v-toolbar-title>Aprobación de oficina de planeación del
                                sector</v-toolbar-title>
                              <template v-slot:actions>
                                <v-icon color="teal">info</v-icon>
                              </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-app-bar>
                                <v-autocomplete :items="gpersonas" v-model="valPunto.idpersonaaprobador"
                                  v-on:change="chagepersonaaprobador" item-text="nombre" item-value="idpersona"
                                  label="Buscar Aprobador:" :readonly="true">
                                  <template v-slot:append-outer>
                                    <v-slide-x-reverse-transition mode="out-in">
                                      <v-icon :color="colorAprobador" @click="dialogasignaraprobador = true"
                                        :disabled="readcontrol('idpersonaaprobador') && !admineditar">mdi-database-search</v-icon>
                                    </v-slide-x-reverse-transition>
                                  </template>
                                </v-autocomplete>
                              </v-app-bar>
                              <v-divider></v-divider>
                              <v-card :disabled="editableaprobador">
                                <v-card-text>
                                  <label class="v-label mx-2 primary--text Label-primary">Nombre </label>
                                  <v-text-field class="mx-2 field-disabled" outlined dense
                                    v-model="personaaprobador.nombre" clearable
                                    data-vv-name="nombreaprobador"></v-text-field>

                                  <label class="v-label mx-2 primary--text Label-primary">Cargo </label>
                                  <v-text-field class="mx-2 field-disabled" outlined dense
                                    v-model="personaaprobador.cargo" data-vv-name="cargoaprobador"></v-text-field>

                                  <label class="v-label mx-2 primary--text Label-primary">Entidad </label>
                                  <v-autocomplete outlined dense v-model="personaaprobador.identidad" :items="Entidades"
                                    item-text="nombre" item-value="identidad"
                                    data-vv-name="entidadAprobador"></v-autocomplete>

                                  <label class="v-label mx-2 primary--text Label-primary">Dependencia </label>
                                  <v-text-field class="mx-2 field-disabled" outlined dense
                                    v-model="personaaprobador.dependencia"></v-text-field>

                                  <label class="v-label mx-2 primary--text Label-primary">Correo Electrónico </label>
                                  <v-text-field class="mx-2 field-disabled" outlined dense
                                    v-model="personaaprobador.correo" data-vv-name="correoaprobador"></v-text-field>
                                </v-card-text>
                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-flex>

                      <v-flex xs12 sm6 class="col-padd">
                        <v-text-field value="Date()" label="Fecha de validación:" clearable
                          v-show="showcontrol('fechavalidacion')"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 class="col-padd">
                        <v-text-field value="Date()" label="Fecha de Revisión:" clearable
                          v-show="showcontrol('fecharevision')"></v-text-field>
                      </v-flex>

                    </v-layout>
                  </v-card-text>
                </v-card>

              </v-tab-item>
              <v-tab-item>
                <historico :idtabla="2" :idelemento="valPunto.idindicador"></historico>
              </v-tab-item>
              <v-tab-item>
                <auditoriasoportes :idtabla="2" :idregistro="valPunto.idindicador"></auditoriasoportes>
              </v-tab-item>
            </v-tabs>
            <br />
            <v-layout row wrap>
              <v-flex sm8 xs12>
                <v-alert color="#f7ffb4" type="info" elevation="2">
                  <p class="font-weight-light" style="color:black">{{disclaimer}}</p>
                </v-alert>
              </v-flex>
              <v-flex sm4 xs12>
                <label class="tit-requerid">*</label><label
                  class="v-label primary--text Label-primary">Certifica</label>
                <v-select dense :items="Controlcertifica" item-text="nombre" item-value="valor" outlined compact
                  class="mx-2" v-model="valPunto.certifica"
                  :readonly="readcontrol('certifica') && !admineditar"  v-show="showcontrol('certifica')"
                  ></v-select>
              </v-flex>

              <v-divider></v-divider>

              <v-flex v-if="(elemento_coment>= 0 && gtareasbyelemento.idrol != undefined) && readcontrol('codigo')">
                <v-card :loading="loading" :disabled="loading" v-if="!finalizardeshabilitado()">
                  <comentarios :tabla="tabla_coment" :elemento="elemento_coment" :campo="7" title="Concepto técnico"
                  :lectura="buttonguardarestado" :EsDelagado="isUserDelegate" :EsConceptoTecnico="true" :rolbyAccion="gtareasbyelemento.idrol" :idflujoaccion="gtareasbyelemento.idflujo"></comentarios>
                </v-card>
              </v-flex>

            </v-layout>

          </v-card-text>
          <v-card-actions>

            <v-btn color="secundary" @click="LlamadoAlert('cancelar')">
              <v-icon small right color="white">fa-regular fa-stop</v-icon> CANCELAR
            </v-btn>

            <v-spacer></v-spacer>
            <v-btn color="primary" @click="LlamadoAlert('guardarformulario')" :disabled="buttonguardarestado"
              v-show="!showcontrol('comentarioflujo')">
              <v-icon small right color="white">fa-regular fa-stop</v-icon> GUARDAR INDICADOR
            </v-btn>

            <v-btn color="primary" @click="LlamadoAlert('finalizarformulario')"
              :disabled="finalizardeshabilitadodelegado()" v-show="!showcontrol('comentarioflujo')"> ENVIAR A REVISIÓN
              <v-icon small right color="white">fa-regular fa-check</v-icon>
            </v-btn>


            <v-btn color="primary" @click="dialogValiddor = true;" :disabled="finalizardeshabilitado()"
              v-show="showcontrol('comentarioflujo')"> FINALIZAR REVISIÓN
              <v-icon small right color="white">fa-regular fa-check</v-icon>
            </v-btn>

          </v-card-actions>
        </v-card>

        <br />

      </v-container>
    </v-app>

    <v-snackbar v-model="snack" :timeout="timeoutsnak" :color="MesaggeInfo.color">
      {{ this.MesaggeInfo.codigoRespuesta }}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      <v-btn text @click="functionalert">{{ buttontext }}</v-btn>
    </v-snackbar>
    <!-- <soportecambio ref="sc" :idtabla="[2, 7]"></soportecambio> -->
    <v-dialog v-model="dialogAlert" width="540" persistent>
      <v-flex>
        <v-card>
          <v-card-text>
            <div class="py-2"></div>
            <div class="py-1 text-center">
              <svg v-show="inconAlert == 'question'" fill="#36c" xmlns="http://www.w3.org/2000/svg" height="3em"
                viewBox="0 0 512 512" style="vertical-align: bottom;">
                <path
                  d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
              </svg>
              <svg v-show="inconAlert == 'check'" fill="#36c" xmlns="http://www.w3.org/2000/svg" height="3em"
                viewBox="0 0 512 512" style="vertical-align: bottom;">
                <path
                  d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
              </svg>
              <svg v-show="inconAlert == 'alert'" fill="#36c" xmlns="http://www.w3.org/2000/svg" height="3em"
                viewBox="0 0 512 512" style="vertical-align: bottom;">
                <path
                  d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
              </svg>
              <v-progress-circular v-show="inconAlert == 'loading'" indeterminate color="primary" model-value="20"
                :size="42" :width="5"></v-progress-circular>
              <p class="dx-popup-msg dx-popup-msg-tit">{{ tituloAlert }}</p>
            </div>

            <div class=" py-1 dx-popup-msg" v-show="subtituloAlert.length > 0">
              <svg v-show="inconAlert == 'question'" fill="#36c" xmlns="http://www.w3.org/2000/svg" height="1em"
                viewBox="0 0 512 512">
                <path
                  d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
              </svg>
              <svg v-show="inconAlert == 'alert'" fill="#36c" xmlns="http://www.w3.org/2000/svg" height="1em"
                viewBox="0 0 512 512">
                <path
                  d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
              </svg>
              {{ subtituloAlert }}
            </div>
            <v-divider></v-divider>
          </v-card-text>
          <v-card-actions>
            <v-btn color="secundary" @click="dialogAlert = false" v-show="buttonCancelarAlert">
              <v-icon small right color="white">fa-regular fa-stop</v-icon> CANCELAR
            </v-btn>
            <v-spacer v-show="buttonCancelarAlert"></v-spacer>
            <v-btn color="primary" @click="OperacionAprobacion()" v-show="buttonAceptarAlert">
              <v-icon small right color="white">fa-solid fa-check</v-icon> ACEPTAR
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-dialog>

    <v-dialog v-model="dialogValiddor" width="750" persistent>
      <v-flex xs12 sm12 v-show="showcontrol('comentarioflujo')">
        <v-card tile :loading="loading" :disabled="loading" v-if="valPunto != null">
          <v-toolbar flat dark color="primary">
            <v-toolbar-title>Revisión del Indicador ({{ valPunto.codigo }})</v-toolbar-title>
            <div class="flex-grow-1"></div>
          </v-toolbar>
          <v-card-text>
            <v-flex xs12 sm12>
              <label for="revisioncomentario" class="form-label">Comentario</label>
              <quill-editor ref="revisioncomentario" id="revisioncomentario" data-vv-name="revisioncomentario"
                :error-messages="errors.collect('revisioncomentario')" v-model="valPunto.comentarioflujo"
                :disabled="readcontrol('comentarioflujo') == true" :options="editorOptionsRevisionComentario"
                @ready="onEditorReady($event)" />
              <div id="counter" class="counter"></div>
            </v-flex>
            <v-flex row>
              <v-flex xs6 sm6>

                <!-- <div
                  v-if="valPunto.idestado == 3 && valPunto.fichavalidada == true && valPunto.fichaaprobada == false && valPunto.rolaprobado == 2">
                  <v-select :items="Rol_dropdown.filter((p) => p.value == 2)" v-model="valPunto.rolaprobado"
                    item-text="text" v-show="showcontrol('fichaaprobada')" :disabled="true" item-value="value"
                    label="Seleccione Rol" class="mx-2" clearable @change="actualizaRolaparobado">
                  </v-select>
                </div>
                <div v-else>
                  <v-select :items="Rol_dropdown.filter((p) => p.value != currentRol[0] && p.value != 2) "
                    v-model="valPunto.rolaprobado" item-text="text" v-show="showcontrol('fichaaprobada')"
                    :disabled="valPunto.fichaaprobada == true || (currentRol[0] != 3)" item-value="value"
                    label="Seleccione Rol" class="mx-2" clearable @change="actualizaRolaparobado">
                  </v-select>
                </div> -->


              </v-flex>
              <v-flex xs6 sm6>
                <v-card :disabled="!(valPunto.comentarioflujo != null)">
                  <!-- <v-select :items="dropdown_comment" v-model="valPunto.fichaaprobada" item-text="text"
                    v-show="showcontrol('fichaaprobada')"
                    :disabled="!(valPunto.rolaprobado == 0 || valPunto.rolaprobado == null || valPunto.rolaprobado == 2)"
                    item-value="value" label="Seleccione opción" class="mx-2" clearable
                    @change="SelecciondeValidador"></v-select> -->

                  <div v-if="currentRol[0] == 3 && valPunto.idestado != 3">
                    <!-- <v-select :items="dropdown_comment" v-model="valPunto.fichavalidada" item-text="text"
                      v-show="showcontrol('fichavalidada')" item-value="value" label="Seleccione opción" class="mx-2"
                      clearable></v-select> -->
                  </div>
                  <div v-else>
                    <!-- <v-select :items="dropdown_comment.filter((p) => p.id != 2 )" v-model="valPunto.fichavalidada" item-text="text" v-show="showcontrol('fichavalidada')" -->
                    <!-- <v-select :items="dropdown_comment" v-model="valPunto.fichavalidada" item-text="text"
                      v-show="showcontrol('fichavalidada')" item-value="value" label="Seleccione opción" class="mx-2"
                      clearable></v-select> -->
                  </div>
                </v-card>
              </v-flex>
            </v-flex>
          </v-card-text>
          <v-card-actions>

            <v-btn color="secundary" @click="dialogValiddor = false" v-show="buttonCancelarAlert">
              <v-icon small right color="white">fa-regular fa-stop</v-icon> CANCELAR
            </v-btn>
            
            
            <v-spacer v-show="buttonCancelarAlert"></v-spacer>
            <v-card :disabled="!(valPunto.comentarioflujo != null)" :elevation="0">
            <v-container>
            <v-layout row wrap style="justify-self: right;">
              <div v-for="(item, index) in gControlesbyflujo" :disabled="!(valPunto.comentarioflujo != null)">
                <v-flex>
                  <v-btn :color="item.color" @click="BotonesGenericosFlujo(item.value)" class="mx-2" >
                     {{ item.nombre }}
                  </v-btn>
                </v-flex>
              </div>
            </v-layout>
          </v-container>
          </v-card>

            <!-- <v-btn color="primary" @click="LlamadoAlert('finalizarvalidador')" v-show="buttonAceptarAlert">
              <v-icon small right color="white">fa-solid fa-check</v-icon> ACEPTAR
            </v-btn> -->
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-dialog>


    <v-dialog v-model="dialogSoportes" width="800" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Soportes de la versión
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col xs12 sm6 md6 style="align-content: center;">
              <v-layout row wrap>
                <v-text-field data-vv-name="numeroradicado" v-model="versionadodatosadicionales.numeroradicado"
                  label="Número radicado" :clearable="this.puedeeditar()" v-validate="'required|numeric'" :counter="50"
                  data-vv-scope="versionadodatosadicionales"
                  :error-messages="errors.collect('numeroradicado', 'versionadodatosadicionales')">
                </v-text-field>
                <v-btn class="mx-1" style="align-self:center" icon color="primary" @click="BuscarAuditoriaporRadicado">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-layout>
            </v-col>
            <v-col xs12 sm6 m6>
              <v-menu ref="menuSoportes" v-model="menuSoportes" :close-on-content-click="false"
                transition="scale-transition" offset-y min-width="290px" readonly>
                <template v-slot:activator="{ on }">
                  <div>
                    <v-text-field v-model="fechaformateada" label="Fecha radicado:" prepend-icon="event" v-on="on"
                      v-validate="'required'" data-vv-name="fecharadicado" data-vv-scope="versionadodatosadicionales"
                      :error-messages="errors.collect('fecharadicado', 'versionadodatosadicionales') "
                      @blur="fecharadicado = parseDate(fechaformateada)"></v-text-field>
                  </div>
                </template>
                <div>
                  <v-date-picker v-model="fecharadicado" no-title scrollable locale="es">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menuSoportes = false">Cancel
                    </v-btn>
                    <v-btn text color="primary" readonly @click="$refs.menuSoportes.save(fechaformateada)">OK</v-btn>
                  </v-date-picker>
                </div>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col xs12 sm12 m12>
              <v-textarea v-model="versionadodatosadicionales.comentario" label="Comentario:" v-validate="'required'"
                data-vv-name="comentario" data-vv-scope="versionadodatosadicionales" :error-messages="errors.collect('comentario', 'versionadodatosadicionales')
        " :clearable="this.puedeeditar()"></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col xs12 sm12 m12>
              <v-data-table :headers="headerFieldsSoportes" :items="soportes" class="elevation-2"
                :no-data-text="gnodata" dense :items-per-page="10" item-key="idsporte">
                <template v-slot:item.action="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" small class="mr-2" @click="deletesoporteversion(item)">delete</v-icon>
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" small class="mr-2" @click="descargarsoporte(item)">mdi-file</v-icon>
                    </template>
                    <span>Descargar</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-flex row>
            <v-flex xs12 md10 sm10>
              <template>
                <v-file-input accept=".pdf, .xlsx, .xls" v-model="fileversionadosoporte" show-size multiple
                  label="cargar archivo" @change="onVersionadoSoporteChange"></v-file-input>
              </template>
            </v-flex>
            <v-flex xs12 md2 sm2>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn outlined v-on="on" class="ma-2" @click="Addversionadosoporte" tile color="success">
                    <v-icon left>add</v-icon>Agregar
                  </v-btn>
                </template>
                <span>Agregar archivo</span>
              </v-tooltip>
            </v-flex>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="blue darken-1" @click="dialogSoportes = false">Cancelar</v-btn>
          <v-btn class="text-white" color="blue darken-1" @click="preventguardardatosadicionales"
            v-show="!buttonguardarestado">Guardar</v-btn>
        </v-card-actions>
      </v-card>
      <v-snackbar v-model="snack" :timeout="timeoutsnak" :color="MesaggeInfo.color">
        {{ this.MesaggeInfo.codigoRespuesta }}
        {{ this.MesaggeInfo.mensajeRespuesta }}
        <v-btn text @click="functionalert">{{ buttontext }}</v-btn>
        <v-btn text v-show="snackalert" @click="cancelsave">Cancelar</v-btn>
      </v-snackbar>
    </v-dialog>
  </div>
</template>

<script>

import { mapActions, mapGetters } from "vuex";
import store from "../../stores/index.js";
import moment from "moment";
import historico from "../../components/content/historico";
import auditoriasoportes from "../../components/content/auditoriasoportes";
import soportecambio from "../../components/content/soportecambio";

import basicos_cadenavalor from "../../components/indicador/cadenaValor_fichatecnica";
import serie_historica from "../../components/indicador/seriehistorica";
import tipovalor_comp from "../../components/indicador/tipovalor";

import comentarios from "../../components/content/comentario";
import Counter from "../../components/global/counter.js";
import { ErrorBag } from 'vee-validate';
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill';
var Delta = Quill.import('delta');
Quill.register('modules/counter', Counter);

export default {
  name: "FichaTecnicaIndicadores",

  data() {
    return {
      rangeslidermax: new Date().getFullYear() -1,
      idrolseguntarea:-1,
      LoadingSeries: false,
      rangeslidermin: 2016,
      tieneseriehistorica: false,
      tabla_coment: 2,
      isUserDelegate: false,
      isUserValidador:false,
      msgValidacion: false,
      obligaValidar: false,
      rangeyears: [null, null],
      TodasEntidades: null,
      elemento_coment: -1,
      campo_coment:-1, 
      ComentariosMetodologia: [],
      ComentariosMetas: [],
      BaseSingleselect: true,
      currentRol: [],
      idindicador: null,
      valPunto: null,
      loading: false,
      sector: null,
      TipoValorSelected: [],
      tipoclasificadorNavigation: null,
      itemunidadselection: null,
      UnidadMedidas: [],
      Tipoclasificadores: [],
      clasificacionetnico: false,
      FechaLineaB: ["2017", "2018", "2019", "2020", "2021"],
      headerMetasFilter:[],
      headerMetasCuatrFilter:[],
      HeaderMetasVigencia: [
        { text: "Año", value: "periodo", align: "center" },
        { text: "Meta", value: "valor", align: "center" },
        { text: "Meta propuesta", value: "metaTmp", align: "center" },
        { text: "Acciones", value: "action", sortable: false },
      ],
      HeaderMetasCuatrenio: [
        { text: "Periodo", value: "periodo", align: "center" },
        { text: "Meta", value: "valor", align: "center" },
        { text: "Meta propuesta", value: "metaTmp", align: "center" }
      ],
      HeaderHitos: [
        { text: "Descripción", value: "descripcion", align: "justify" },
        {
          text: "Ponderación",
          value: "ponderacion",
          align: "center",
          width: 150,
        },
        {
          text: "Fecha cumplimiento",
          value: "fechacumplimiento",
          align: "center",
          width: 200,
          format: "MM-DD-YYYY",
        },
        { text: "Acciones", value: "action", sortable: false, width: 100 },
      ],      
      MetasCuatrenio: [],
      MetasVigencia: [],
      MetasCuatrenioext: [],
      MetasVigenciaext: [],
      TAcumulacion: [],
      DescripcionAcumulacion: '',
      DescripcionTipoIndicador: '',
      Entidades: [],
      entidad: null,
      Hitos: [],
      dialog: false,
      dialogMeta: false,
      dialogMetaext: false,
      dialogMetaCuatrenio: false,
      dialogentidadMain: false,
      dialogasignargerente: false,
      dialogasignaraprobador: false,
      //Soportes
      fecharadicado: new Date().toISOString().substr(0, 10),
      fecharadicadoseleccionada: null,
      fechaformateada: '',
      tiposarchivo: null,
      soportes: [],
      fileversionadosoporte: null,
      dialogSoportes: false,
      dialogAlert: false,
      dialogValiddor: false,
      tituloAlert: '',
      subtituloAlert: '',
      operacionAlert: '',
      buttonAceptarAlert: true,
      buttonCancelarAlert: true,
      inconAlert: '',
      snackalert: false,
      versionadodatosadicionales: { numeroradicado: '', fecharadicado: '', comentario: '', fecharadicadoformateada: '' },
      headerFieldsSoportes: [
        {
          value: "nombrearchivo",
          text: "Nombre",
          sortable: true,
          width: "150px",
        },
        { text: "Acciones", value: "action", sortable: false, width: "10%" }
      ],
      menuSoportes: false,
      //Fin Soportes
      idtabla: [2, 7],
      timeoutsnak: 4000,
      buttontext: "cerrar",
      editedIndex: -1,
      editedIndexMeta: -1,
      editedIndexCuatrenio: -1,
      menu: false,
      menu2: false,
      picker: new Date().toISOString().substr(0, 10),
      editedItem: {
        descripcion: "",
        ponderacion: 0,
        fechacumplimiento: "",
        idindicador: 0,
        cumplido: false,
      },
      defaultItem: {
        descripcion: "",
        ponderacion: 0,
        fechacumplimiento: "",
        idindicador: 0,
        cumplido: false,
      },
      editedItemMeta: { valor: 0 },
      editedItemCuatrenio: { valor: 0 },
      defaultItemMeta: { valor: 0 },
      snack: false,
      snackColor: "",
      snackText: "",
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      switchTerritorio: "",
      switchrequierehito: "",
      Entidadselected: [],
      responsableselected: [],
      Controlcertifica: [{nombre: "Sí", valor: true}, {nombre: "No", valor: false}],
      personagerente: {
        nombre: "",
        cargo: "",
        identidad: "",
        dependencia: "",
        correo: "",
        telefono: "",
        idpersona: 0,
      },
      personagerentebuscar: {
        nombre: "",
        cargo: "",
        identidad: "",
        dependencia: "",
        correo: "",
        telefono: "",
        idpersona: 0,
      },
      newpersonagerente: {
        nombre: "",
        cargo: "",
        identidad: "",
        dependencia: "",
        correo: "",
        telefono: "",
        idpersona: 0,
      },
      personaaprobador: {
        nombre: "",
        cargo: "",
        identidad: "",
        dependencia: "",
        idpersona: 0,
        correo: "",
      },
      personaaprobadorbuscar: {
        nombre: "",
        cargo: "",
        identidad: "",
        dependencia: "",
        idpersona: 0,
        correo: "",
      },
      newpersonaaprobador: {
        nombre: "",
        cargo: "",
        identidad: "",
        dependencia: "",
        idpersona: 0,
        correo: "",
      },
      personas: {},
      isEditingGerente: false,
      isEditingAprobador: false,
      editablegerente: true,
      editableaprobador: true,
      estadocampos: [],
      colorGerenteMeta: "info",
      colorAprobador: "info",
      tienelineabase: '',
      tptieneavances: false,
      usuarioregistrado: [],
      userautenticado: false,
      buttonguardarestado: true,
      buttonfinalizarestado: true,
      buttonrevision: true,
      territorializacionselect: [],
      dialogrevision: false,
      dropdown_comment: [
        { id: 1, text: "Aprobar", value: true },
        { id: 2, text: "Rechazar", value: false }
      ],
      Rol_dropdown: [
        { id: 0, text: "Validador", value: 3 },  
        { id: 1, text: "DT", value: 9 },
        { id: 2, text: "Enlase DT", value: 10 },
        { id: 3, text: "Delegado", value: 2 }
      ],
      timewait: 3,
      IndicadorFiltrado: [],
      ItemsClasificador: [],
      //utilizamos esta variable para verificar que estamos en edicion
      estadorevision: false,
      admineditar: false,
      recargadata: false,
      returpath: "",
      sortBy: "fechacumplimiento",
      sortDesc: false,
      //isrefreshmeta: false,
      idtipoacumulacion: null,
      disclaimer: 'El rol “Delegado” tiene el deber de garantizar que la información registrada es veraz y coherente con la implementación del indicador. El usuario Delegado de la entidad ¿Certifica que los datos ingresados cumplen con los criterios definidos por Sinergia - SIIPO y garantiza que la ficha técnica que se registra en el sistema ha sido propuesta y validada por el área misional encargada de la implementación del indicador y es aprobada por el responsable de planeación de la entidad?',
      dictionary: {
        custom: {
          inicio: {
            required: () => ""
          },
          fin: {
            required: () => ""
          },          
          descripcion: {
            required: () => "El campo descripcion no puede estar en blanco",
            max: "está superando el límite de caracteres",
          },
          formulacalculo: {
            required: () =>
              "El campo fórmula de cálculo no puede estar en blanco",
            max: "está superando el límite de caracteres",
          },
          diasrezago: {
            required: () => "El campo dias de rezago es requerido",
            numeric: "El campo solo recibe números enteros",
          },
          lineabase: {
            decimal: "solo numeros con el siguiente formato (.##) ",
            required_if: () => "La liena base es requerido",
          },
          descripcionlineabase: {
            required: () => "El campo descripción es requerido",
            required_if: () => "El campo descripción es requerido",
          },
          fuentelineabase: {
            required: () => "El campo fuente es requerido",
            required_if: () => "El campo fuente es requerido",
          },
          argumentonolineabase: {
            required: () => "Debe argumentar porque no tiene line base",
            required_if: () => "Debe argumentar porque no tiene line base",
          },

          MetasVigencia: {
            decimal: "solo numeros con el siguiente formato (.##) ",
          },
          Metas: {
            decimal: "solo numeros con el siguiente formato (.##) ",
          },
          metodologiamedicion: {
            required: () =>
              "El campo metodología de medición no puede estar en blanco",
            max: "está superando el límite de caracteres",
          },
          fuenteinformacion: {
            required: () =>
              "El campo fuente de información no puede estar en blanco",
            max: "está superando el límite de caracteres",
          },
          observacionadicional: {
            max: "está superando el límite de caracteres",
          },
          metastrazadorasobs: {
            max: "está superando el límite de caracteres",
          },
          observacionetnicosobs: {
            max: "está superando el límite de caracteres",
          },
          newnombregerente: {
            required: () => "El campo nombre gerente no puede estar en blanco",
            max: "está superando el límite de caracteres",
          },
          newcargogerente: {
            required: () => "El campo cargo gerente no puede estar en blanco",
            max: "está superando el límite de caracteres",
          },
          newcorreogerente: {
            required: () => "El campo Correo del gerente es requerido",
            email: () => "El correo electrónico es inválido",
          },
          newcorreoaprobador: {
            required: () => "El campo Correo del aprobador es requerido",
            email: () => "El correo electrónico es inválido",
          },
          newnombreaprobador: {
            required: () =>
              "El campo nombre aprobador no puede estar en blanco",
            max: "está superando el límite de caracteres",
          },
          newcargoaprobador: {
            required: () => "El campo cargo aprobador no puede estar en blanco",
            max: "está superando el límite de caracteres",
          },
          newdependenciaaprobador: {
            required: () => "El campo cargo dependencia no puede estar en blanco",
            max: "está superando el límite de caracteres",
          },
          newentidadgerente: {
            required: () => "Debe seleccionar una entidad",
          },
          newentidadaprobador: {
            required: () => "Debe seleccionar una entidad",
          },
          ponderacionhito: {
            required: () => "El campo cargo aprobador no puede estar en blanco",
          },
          descripcionmetodologia: {
            required: () => "La descripción de la metodología es requerida",
          },
          descripcionhito: {
            required: () =>
              "El campo descripcion del hito no puede estar en blanco",
            max: "está superando el límite de caracteres",
          },
          revisioncomentario: {
            max: "está superando el límite de caracteres",
          },
          Radioterritorialindicador: {
            required: () => "Debe seleccionar una opción de territorialización",
          },
          Radiodesagregacion: {
            required: () =>
              "Debe seleccionar una opción de desagregación poblacional",
          },
          RadioPertenencia: {
            required: () => "Debe seleccionar una opción de Pertenencia étnica",
          },
          tipoindicador: {
            required: () => "El campo tipo de indicador es requerido",
          },
          idtipoacumulacion: {
            required: () => "El campo tipo de acumulación es requerido",
          },
          idorientacion: {
            required: () => "El campo orientación es requerido",
          },
          unidadmedida: {
            required: () => "El campo unidad medida es requerido",
          },
          idperiodicidadactualizacion: {
            required: () => "El campo periodicidad de medicion es requerido",
          },
          idmetodologia: {
            required: () => "El campo metodología de proyeccion es requerido",
          },
          entidadselect: {
          required: () => "debe seleccionar una entidad como mínimo",
          },
          responsableselect: {
            required: () => "Debe seleccionar como mínimo un responsable PMI",
          },
          otraMetedologiaPM: {
            required: () => "Si selecciono otro Metodología debe describirla",
          }
        },


      },
      quill: null,
      editorOptionsRevisionComentario: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ indent: "-1" }, { indent: "+1" }],
            ],
          },
          counter: {
            container: '#counter',
            controlContainer: '#revisioncomentario',
            unit: 'letra',
            max: 500
          },
          clipboard: {
            matchers: [
              [Node.ELEMENT_NODE, function (node, delta) {
                return delta.compose(new Delta().retain(delta.length(),
                  {
                    align: "justify",
                    link: false,
                    color: false,
                    size: "12px",
                    header: false
                  }
                ));
              }
              ]
            ]
          }
        },
        placeholder: "",
      },
    };
  },
  components: {
    historico,
    tipovalor_comp,
    basicos_cadenavalor,
    comentarios,
    auditoriasoportes,
    soportecambio,
    quillEditor,
    serie_historica
  },
  $_veeValidate: {
    validator: "new",
  },
  mounted() {
    this.$validator.localize("es", this.dictionary);
  },
  methods: {
    ...mapActions([
      "Indicador_Encabezado",
      "get_unidades",
      "Getperiodicidad",
      "get_metasvigenciaExt",
      "get_metascuatrenioExt",
      "get_metasvigencia",
      "Gettipoacumulacion",
      "Getentidad",
      "get_sectores",
      "Gethitos",
      "PutIndicador",
      "set_information",
      "get_personagerente",
      "get_personaaprobador",
      "get_lista",
      "get_camposestado",
      "get_unidades",
      "get_territorializaciones",
      "reset_indicador",
      "get_TipoIndicador",
      "get_configuraciones",
      "get_tiposclasificadorbyindicador",
      "get_tiposclasificador",
      "get_nacionales",
      "get_porusuario",
      "GenerarMetas",
      "cambiarestadometa",
      "downloadsoporteversion",
      "putversionadodatosadicionalestablas",
      "PutPersona",
      "ClearCache",
      "get_entidadreporta",
      "getmetodologias",
      "Getorientacion",
      "get_soportesversion",
      "get_series",
      "get_generar",
      "Deletemasive",
      "getControlbyFlujo",
      "get_comentarios",
      "get_metastemporales",
      "get_tareaactivabytipo",
      "get_historicotareas"
    ]),
    ...mapActions("usuario/", ["get_usuarios"]),
    ...mapActions("fichatecnica/", [
      "set_permitenacional",
      "set_itemsclasificacion",
      "set_indicador",
    ]),
    asignaraprobador() {
      this.valPunto.idpersonaaprobador = this.valPunto.idpersonaaprobadorbuscar;
      this.personaaprobador = Object.assign({}, this.personaaprobadorbuscar);
      this.personaaprobadorbuscar.nombre = "";
      this.personaaprobadorbuscar.cargo = "";
      this.personaaprobadorbuscar.identidad = "";
      this.personaaprobadorbuscar.correo = "";
      this.personaaprobadorbuscar.dependencia = "",
      this.personaaprobadorbuscar.idpersona = 0;
      this.dialogasignaraprobador = false;

    },
    guardaraprobador() {
      this.$validator.validateAll("newaprobador").then(async (result) => {
        if (!result) {
          this.snack = true;
          this.dialogAlert = false;
          this.snackalert = false;
          this.buttontext = "cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";
          this.$validator.errors.items.forEach((element) => {
            if (element.scope == "newaprobador")
              Errores = Errores + "( " + element.msg + " ), ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "la validación del formulario contiene errores " + Errores;
          this.MesaggeInfo.color = "infovue";
          return;
        }
        else {
          this.loading = true;
          this.newpersonaaprobador.modificado = true;
          let personas = new Array(this.newpersonaaprobador);
          await this.PutPersona({
            data: personas,
          });
          this.newpersonaaprobador.nombre = "";
          this.newpersonaaprobador.cargo = "";
          this.newpersonaaprobador.identidad = "";
          this.newpersonaaprobador.correo = "";
          this.newpersonaaprobador.dependencia = "";
          this.newpersonaaprobador.idpersona = 0;
          this.$validator.reset();
          await this.ClearCache();
          await this.get_lista();
          this.loading = false;
        }
      });
    },
    asignargerente() {
      this.valPunto.idpersonagerente = this.valPunto.idpersonagerentebuscar;
      this.personagerente = Object.assign({}, this.personagerentebuscar);
      this.personagerentebuscar.nombre = "";
      this.personagerentebuscar.cargo = "";
      this.personagerentebuscar.identidad = "";
      this.personagerentebuscar.dependencia = "";
      this.personagerentebuscar.correo = "";
      this.personagerentebuscar.telefono = "";
      this.personagerentebuscar.idpersona = 0;
      this.dialogasignargerente = false;
    },
    guardargerente() {
      this.$validator.validateAll("newgerente").then(async (result) => {
        if (!result) {
          this.snack = true;
          this.dialogAlert = false;
          this.snackalert = false;
          this.buttontext = "cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";
          this.$validator.errors.items.forEach((element) => {
            if (element.scope == "newgerente")
              Errores = Errores + "( " + element.msg + " ), ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "la validación del formulario contiene errores " + Errores;
          this.MesaggeInfo.color = "infovue";
          return;
        }
        else {
          this.loading = true;
          this.newpersonagerente.modificado = true;
          let personas = new Array(this.newpersonagerente);
          await this.PutPersona({
            data: personas,
          });
          this.newpersonagerente.nombre = "";
          this.newpersonagerente.cargo = "";
          this.newpersonagerente.identidad = "";
          this.newpersonagerente.dependencia = "";
          this.newpersonagerente.correo = "";
          this.newpersonagerente.telefono = "";
          this.newpersonagerente.idpersona = 0;
          this.$validator.reset();
          await this.ClearCache();
          await this.get_lista();
          this.loading = false;
        }
      });
    },
    //Soportes
    deletesoporteversion(item) {
      const index = this.soportes.indexOf(item);
      if (confirm("Desea eliminar el soporte?")) {
        this.deletesoporteVersion.push(item);
        this.soportes.splice(index, 1);
      }
    },
    descargarsoporte(item) {
      console.log('item 1', this.idtabla[0])
      console.log('this.idregistro', this.idregistro)
      console.log('item.idsoporte', item.idsoporte)
      if (item.archivocompleto == null) {
        this.downloadsoporteversion({
          params: {
            idtabla: this.idtabla[0],
            idindicador: this.idregistro,
            idsoporte: item.idsoporte
          }
        });
      } else {
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        a.href = item.archivocompleto;
        a.setAttribute("download", item.nombrearchivo);
        a.click();
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      }
    },
    onVersionadoSoporteChange() {
      this.imageUrlversionadosoporte = [];
      let error = false;
      if (this.fileversionadosoporte !== null) {
        for (let i = 0; i < this.fileversionadosoporte.length; i++) {
          if (error === false) {
            let file = this.fileversionadosoporte[i];
            let tipo = file.type.replace("application/", "");
            if (this.tiposarchivo.indexOf(tipo, 0) > 0) {
              if (file.size > this.tamanoarchivo * 1024000) {
                this.MesaggeInfo.mensajeRespuesta =
                  "El tamaño de uno de los archivos supera el límite de carga (" +
                  this.tamanoarchivo +
                  "Mb)";
                this.MesaggeInfo.color = "errorvue";
                this.snack = true;
                this.dialogAlert = false;
                error = true;
              } else {
                let actual = this.soportes.filter(
                  p =>
                    p.nombrearchivo === file.name &&
                    (p.idversionado === this.selectedversionado)
                )[0];
                if (actual === undefined) {
                  let reader = new FileReader();
                  reader.onload = () => {
                    this.imageUrlversionadosoporte.push(reader.result);
                  };
                  reader.readAsDataURL(file);
                } else {
                  this.MesaggeInfo.mensajeRespuesta =
                    "Uno de los archivos ya se encuentra relacionado en la versión";
                  this.MesaggeInfo.color = "errorvue";
                  this.snack = true;
                  this.dialogAlert = false;
                  error = true;
                }
              }
            } else {
              this.MesaggeInfo.mensajeRespuesta =
                "Uno de los archivos no es compatible con los tipos permitidos";
              this.MesaggeInfo.color = "errorvue";
              this.snack = true;
              this.dialogAlert = false;
              error = true;
            }
          }
        }
        if (error === true) {
          this.imageUrlversionadosoporte = [];
          this.fileversionadosoporte = [];
        }
      }
    },
    Addversionadosoporte() {
      if (this.fileversionadosoporte !== null) {
        for (let i = 0; i < this.fileversionadosoporte.length; i++) {
          let file = this.fileversionadosoporte[i];

          this.soporteversion = Object.assign({}, this.soportes);
          this.soporteversion.nombrearchivo = file.name,
            this.soporteversion.tipoarchivo = file.type,
            this.soporteversion.finalizado = false,
            this.soporteversion.archivocompleto = this.imageUrlversionadosoporte[i],
            this.soporteversion.idsoporte = 0

          this.soportes.push(this.soporteversion);
        }
        this.imageUrlversionadosoporte = [];
        this.fileversionadosoporte = [];
      } else {
        this.MesaggeInfo.mensajeRespuesta =
          "Seleccione un archivo para la carga";
        this.MesaggeInfo.color = "infovue";
        this.snack = true;
        this.dialogAlert = false;
      }
    },
    cancelsave() {
      this.snackalert = false;
      this.snack = false;
      this.buttontext = "cerrar";
      this.timeoutsnak = 4000;
    },
    guardarIndicadorSegunRol() {

      let user = this.getusuario();
      let RolAdmin = user.usuarioRol.map(item => { return item.idrol == 1 });

      if (this.puedeeditar()) {
        if (RolAdmin[0] == true)
          this.dialogSoportes = true;
        else if (this.valPunto.avancesgenerados == true) {
          this.dialogSoportes = true;
        } else if (this.valPunto.avancesgenerados == false) {
          localStorage.setItem('radicado', '')
          if (this.SaveIndicador() == true){
            console.log('Save I segun rol 1')
            this.CuadroDialogo('Guardando indicador ' + this.valPunto.codigo , 'Un momento por favor', false, false, 'loading', true, false)
          }
        }
      }
      else {
        if (this.SaveIndicador()  == true) {
          console.log('Save I segun rol 2')
          this.CuadroDialogo('Guardando indicador', 'Un momento por favor', false, false, 'loading', true, false)
        }
      }
    },  
    preventguardardatosadicionales() {
      this.$validator.validateAll("versionadodatosadicionales").then(async (result) => {
        if (!result || this.soportes.length == 0) {
          this.snack = true;
          this.dialogAlert = false;
          this.snackalert = false;
          this.buttontext = "cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";

          let bag = new ErrorBag();
          bag = this.errors;
          if (bag.first('fileversionadosoporte', 'versionadodatosadicionales') !== undefined)
            bag.removeById(bag.first('fileversionadosoporte', 'versionadodatosadicionales').id);
          //bag.remove(bag.first('fileversionadosoporte').id);

          if (this.soportes.length == 0 && bag.first('fileversionadosoporte', 'versionadodatosadicionales') == undefined) {
            bag.add({
              scope: 'versionadodatosadicionales',
              field: 'fileversionadosoporte',
              msg: 'Al menos un archivo de soporte es requerido'
            });
          }

          this.$validator.errors.items.forEach((element) => {
            if (element.scope == "versionadodatosadicionales")
              Errores = Errores + "( " + element.msg + " ), ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "la validación del formulario contiene errores " + Errores;
          this.MesaggeInfo.color = "infovue";

          return;
        } else {
          this.Editarentidad = false;
          this.CuadroDialogo('Guardando indicador', 'Un momento por favor', false, false, 'loading', true, false)
          console.log('prevent datos adicionales')
          await this.SaveIndicador();
          // Guardar los soportes e información adicional de los cambiós, depende de una información que guarda un proceso ejecutado 
          // de manera asincronica al guardar cualquier entidad.
          // Esta a veces no alcanza a terminar por eso se le dan 5 segundos para que termine.
          setTimeout(() => {
            this.Savesoportedatosadicionales();
          }, 5000);

        }
      });

    },
    async Savesoportedatosadicionales() {
      this.loading = true;
      let bytes = window.crypto.getRandomValues(new Uint8Array(32));
      const randomBytes = () => (bytes = bytes.slice(1)) && bytes[0];
      let tran = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ (randomBytes() & (15 >> (c / 4)))).toString(16)
      );
      
            
      localStorage.setItem('radicado', this.versionadodatosadicionales.numeroradicado)
      await this.putversionadodatosadicionalestablas({
        data: {
          idtabla: this.idtabla,
          versionadoDatosAdicionales: {
            idversionadodatosadicionales: this.versionadodatosadicionales.idversionadodatosadicionales,
            comentario: this.versionadodatosadicionales.comentario,
            numeroradicado: this.versionadodatosadicionales.numeroradicado,
            fecharadicado: this.versionadodatosadicionales.fecharadicado
          },
          soportesVersionado: this.soportes,
          soportesEliminar: this.deletesoporteVersion
        }
      });

      this.deletesoporteVersion = [];
      this.dialogSoportes = false;
      this.loading = false;
    },
    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    formato(value, sinhora) {
      if (value && sinhora == false) {
        return moment(String(value)).format("DD/MM/YYYY HH:mm");
      }
      else {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },    
    //Fin Soportes
    verauditoria() {
      let opciones = this.gopciones.filter((p) => p.codigo === "O004-1-7")[0];
      return opciones != undefined;
    },
    onEditorReady(quill) {
      quill.format("align", "justify");
    },
    onEditorChange({ quill }) {
      quill.getModule('counter').update();
    },
    getusuario() {
      if (localStorage.usuario !== undefined) {
        return JSON.parse(unescape(localStorage.usuario));
      } else {
        return null;
      }
    },
    close() {
      this.dialog = false;
      this.dialogMeta = false;
      this.dialogMetaext = false;
      this.dialogMetaCuatrenio = false;
      this.dialogentidadMain = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    editItem(item) {
      this.editedIndex = this.Hitos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    editItemMetaVigencia(item) {
      this.editedIndexMeta = this.MetasVigencia.indexOf(item);
      this.editedItemMeta = Object.assign({}, item);
      this.dialogMeta = true;
    },
    async editEstadoMeta(item) {
      if (item.idestado == 1) item.idestado = 6;
      else if (item.idestado == 6) item.idestado = 1;
      this.editedIndexMeta = this.MetasVigencia.indexOf(item);
      this.editedItemMeta = Object.assign({}, item);
      if (this.editedIndexMeta > -1) {
        await this.cambiarestadometa({
          data: this.editedItemMeta,
        });
        this.get_metasvigenciaExt({
          params: {
            idindicador: this.idindicador,
          },
        });
      }
    },
    async editEstadoMetaExt(item) {
      if (item.idestado == 1)
        item.idestado = 6;
      else if (item.idestado == 6)
        item.idestado = 1;

      this.editedIndexMeta = this.MetasVigenciaext.indexOf(item);
      this.editedItemMeta = Object.assign({}, item);
      if (this.editedIndexMeta > -1) {
        await this.cambiarestadometa({ data: this.editedItemMeta });
        this.get_metasvigenciaExt({ params: { idindicador: this.idindicador } });
      }
    },
    editItemMetaCuatrenio(item) {
      if (!item.editable) {
        this.editedIndexCuatrenio = this.MetasCuatrenio.indexOf(item);
        this.editedItemCuatrenio = Object.assign({}, item);
        this.dialogMetaCuatrenio = true;
      } else {
        this.MesaggeInfo.mensajeRespuesta =
          "Este registro de la meta no es editable";
        this.MesaggeInfo.color = "infovue";
        this.snack = true;
        this.dialogAlert = false;
      }
    },
    deleteItem(item) {
      const index = this.Hitos.indexOf(item);
      confirm("¿Esta seguro de eliminar este hito?") &&
        this.Hitos.splice(index, 1);
    },
    save() {
      if (this.editedIndex > -1) {
        this.editedItem.idindicador = this.valPunto.idindicador;
        this.editedItem.cumplido = false;
        Object.assign(this.Hitos[this.editedIndex], this.editedItem);
      } else {
        this.editedItem.idindicador = this.valPunto.idindicador;
        this.Hitos.push(this.editedItem);
      }
      this.MesaggeInfo.mensajeRespuesta =
        "El hito ha sido modificado; los cambios serán permanentes cuando guarde los cambios del indicador";
      this.MesaggeInfo.color = "infovue";
      this.snack = true;
      this.dialogAlert = false;
      this.close();
    },
    saveMetaVigencia() {
      if (this.editedIndexMeta > -1) {
        Object.assign(
          this.MetasVigencia[this.editedIndexMeta],
          this.editedItemMeta
        );
      }

      this.dialogAlert = false;
      this.close();
      this.CuadroDialogo('La meta ha sido modificada; los cambios serán permanentes cuando genere la meta y guarde los cambios del indicador', '', true, false, 'alert', true, true)      
    },
    saveMetaVigenciaExt() {
      if (this.editedIndexMeta > -1) {
        Object.assign(
          this.MetasVigenciaext[this.editedIndexMeta],
          this.editedItemMeta
        );
      }
      this.dialogAlert = false;
      this.close();
      this.CuadroDialogo('La meta ha sido modificada; los cambios serán permanentes cuando genere la meta y guarde los cambios del indicador', '', true, false, 'alert', true, true)      

      
    },
    saveMetaCuatrenio() {
      if (this.editedIndexCuatrenio > -1) {
        Object.assign(
          this.MetasCuatrenio[this.editedIndexCuatrenio],
          this.editedItemCuatrenio
        );
      }
      this.dialogAlert = false;
      this.close();
      this.CuadroDialogo('La meta ha sido modificada; los cambios serán permanentes cuando genere la meta y guarde los cambios del indicador', '', true, false, 'alert', true, true)      

    },
    async SaveIndicador() {
      this.dialogSoportes = false;
      this.valPunto.ajustesAdministrador = this.admineditar;
      this.valPunto.entidades = this.gficha_indicador.entidades;
      this.valPunto.idnacional = this.gficha_indicador.idnacional;
      this.loading = true;
      if (this.personagerente.nombre !== "") {
        this.valPunto.idpersonagerenteNavigation = this.personagerente;
      }
      if (this.personaaprobador.nombre !== "") {
        this.valPunto.idpersonaaprobadorNavigation = this.personaaprobador;
      }
      if (this.valPunto.requierehito) {
        let MesageHitos = "";
        this.Hitos.forEach((element) => {
          if (element.descripcion.length == 0) {
            MesageHitos = MesageHitos + "(La descripción del Hito se encuentra vacía), ";
          }
          if (element.ponderacion.length == 0) {
            MesageHitos = MesageHitos + "(La Ponderación del Hito se encuentra vacía), ";
          }
          if (element.fechacumplimiento.length == 0) {
            MesageHitos = MesageHitos + "(La Fecha de cumplimiento del Hito se encuentra vacía), ";
            return;
          }
        });
        if (MesageHitos.length > 0) {
          this.MensajeReturn( "Se encontraron los siguientes errores en los hitos" + MesageHitos, "warnvue"
          );
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;          
          return;
        }
        this.valPunto.hito = this.Hitos;
      }
      let groupmetas = [];
      

      //if (this.valPunto.idrolresponsable == 3)
      //{
        groupmetas = this.MetasVigencia.concat(this.MetasCuatrenio);
        groupmetas = groupmetas.concat(this.MetasVigenciaext);
        groupmetas = groupmetas.concat(this.MetasCuatrenioext);
      //}

      if (groupmetas.length > 0) {
        this.valPunto.metaNavigation = groupmetas;
      }

      if (this.gficha_itemsclasificacion.length > 0) {
        let clasificadorItem = [];
        this.gficha_itemsclasificacion.forEach((element) => {
          clasificadorItem.push({
            idindicador: this.valPunto.idindicador,
            idtipoclasificador: element,
          });
        });
        this.valPunto.indicadorTiposClasificador = clasificadorItem;
      }

      if (this.Entidadselected.length > 0) {
        let basicItem = [];
        this.Entidadselected.forEach((element) => {
          basicItem.push({
            idindicador: this.valPunto.idindicador,
            identidad: element,
          });
        });
        this.valPunto.indicadorEntidades = basicItem;
      }

      if (this.responsableselected.length > 0) {
        let basic2Item = [];
        this.responsableselected.forEach((element) => {
          basic2Item.push({
            idindicador: this.valPunto.idindicador,
            identidad: element,
          });
        });
        this.valPunto.indicadorResponsable = basic2Item;
      }

      let TerrotirializacionAdd = [];
      if (this.territorializacionselect.length > 0) {
        this.territorializacionselect.forEach((element) => {
          TerrotirializacionAdd.push({
            idindicador: this.valPunto.idindicador,
            idterritorializacion: element,
          });
        });
      }



      if (this.valPunto.idestado == 3 && !this.admineditar) {

        if (this.valPunto.fichaaprobada == null && this.valPunto.rolaprobado == null ) {

          this.CuadroDialogo('debe aprobar o seleccionar un rol al cual enviar la ficha', '', true, false, 'alert', false, true)          
          this.loading = false;
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;          
          return;
        }

        if (this.valPunto.comentarioflujo == null) {

          this.CuadroDialogo('El comentario del indicador no puede estar vacío', '', true, false, 'alert', false, true)
          this.loading = false;
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;
          return;
        }

        if (this.valPunto.metaaprobada == true ) {
          let ConteoModificaciones =  this.MetasVigencia.filter(record => { return record.valor != record.metaTmp; }).length

            if (ConteoModificaciones > 0 ) {
              this.CuadroDialogo('Las metas gestionadas por el delegado se encuentran todavía en la tabla temporal, debe generar las metas antes de aprobar el indicador.', '', true, false, 'alert', false, true)
              this.loading = false;
              this.buttonguardarestado = false;
              this.buttonfinalizarestado = false;
              this.valPunto.metaaprobada == false;
              return;
            }
        }

      }

      if (this.valPunto.idestado == 8 && !this.admineditar) {
        if (this.valPunto.fichavalidada == null) {
          
          this.CuadroDialogo('debe aprobar o rechazar el indicador', '', true, false, 'alert', false, true)
          this.loading = false;
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;
          return;
        }
        if (this.valPunto.comentarioflujo == null || this.valPunto.comentarioflujo == '') {
          
          this.CuadroDialogo('El comentario del indicador no puede estar vacío', '', true, false, 'alert', false, true)
          this.loading = false;
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;
          return;
        }
      }      

      if (this.valPunto.finalizar) {
        if (this.MensajesdeValidacionFinalizar() == false) {          
          return false;
        }
      }

      if (this.AlertasdeTamaños() == false) {
          console.log('alerta de tamaños')
          return false;
      } 
      console.log('Continuo con el guardado')
      this.valPunto.cambiaacumulacion = false;
      if (this.idtipoacumulacion !== this.valPunto.idtipoacumulacion) {
        this.valPunto.cambiaacumulacion = true;
      }
      this.valPunto.indicadorTerritorializaciones = TerrotirializacionAdd;
           
      if (this.$refs.serieComp)
      if (this.$refs.serieComp.anios.length > 0)
      { 
        this.valPunto.seriehistorica = this.$refs.serieComp.anios.flat(); 
      }
      if (this.isUserDelegate) 
        this.CuadroDialogo('Guardando indicador ' + this.valPunto.codigo +' ', 'Un momento por favor', false, false, 'loading', false)
      else 
        this.CuadroDialogo('Enviando indicador ' + this.valPunto.codigo +' a revisión', 'Un momento por favor', false, false, 'loading', false)
      
    if (this.valPunto.finalizar) {
      this.marcarfinalizado();
    }
      
      await this.PutIndicador({
        data: this.valPunto,
      });
      return true;
    },
    MensajeReturn(mesage, color) {
      this.snack = true;
      this.dialogAlert = false;
      this.MesaggeInfo.mensajeRespuesta = mesage;
      this.MesaggeInfo.color = color;
      this.loading = false;
    },
    AlertasdeTamaños(){
      if (this.obligaValidar) {
        if (this.valPunto.descripcion != null)
        if (this.valPunto.descripcion.length > 8000 )
        {
          this.CuadroDialogo('La Descripción del indicador supera el limite de caracteres permitido', '', true, false, 'alert', true, true)    
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;
          this.valPunto.finalizar = false;
          this.loading = false;
          return false;
        }
        if (this.valPunto.formulacalculo != null)
        if (this.valPunto.formulacalculo.length > 2000 )
        {
          this.CuadroDialogo('la Fórmula de cálculo supera el limite de caracteres permitido', '', true, false, 'alert', true, true)    
          
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;
          this.valPunto.finalizar = false;
          this.loading = false;        
          return false;
        }
        if (this.valPunto.fuenteinformacion != null)
        if (this.valPunto.fuenteinformacion.length > 4000 )
        {
          this.CuadroDialogo('las Fuentes de información supera el limite de caracteres permitido', '', true, false, 'alert', true, true)    
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;
          this.valPunto.finalizar = false;
          this.loading = false;        
          return false;
        }
        if (this.valPunto.metodologiamedicion != null)
        if (this.valPunto.metodologiamedicion.length > 8000)
        {
          this.CuadroDialogo('la Metodología de medición supera el limite de caracteres permitido', '', true, false, 'alert', true, true)    
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;
          this.valPunto.finalizar = false;
          this.loading = false;     
          return false;  
        }
        if (this.valPunto.descripcionlienabase != null)
        if (this.valPunto.descripcionlienabase.length > 500 )
        {
          this.CuadroDialogo('la Descripción línea base supera el limite de caracteres permitido', '', true, false, 'alert', true, true)    
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;
          this.valPunto.finalizar = false;
          this.loading = false;       
          return false; 
        }
        if (this.valPunto.fuentebase != null)
        if (this.valPunto.fuentebase.length > 1000 )
        {
          this.CuadroDialogo('la Fuente línea base supera el limite de caracteres permitido', '', true, false, 'alert', true, true)    
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;
          this.valPunto.finalizar = false;
          this.loading = false;    
          return false;    
        }
        if (this.valPunto.comentariolineabase != null)
        if (this.valPunto.comentariolineabase.length > 2000 )
        {
          this.CuadroDialogo('El comentario de linea base supera el limite de caracteres permitido', '', true, false, 'alert', true, true)    
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;
          this.valPunto.finalizar = false;
          this.loading = false;     
          return false;   
        }
        if (this.valPunto.otraMetedologiaPM != null)
        if (this.valPunto.otraMetedologiaPM.length > 500 )
        {
          this.CuadroDialogo('la Otra Metodología supera el limite de caracteres permitido', '', true, false, 'alert', true, true)    
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;
          this.valPunto.finalizar = false;
          this.loading = false;        
          return false;
        }
        if (this.valPunto.descripcionmetodologia != null)
        if (this.valPunto.descripcionmetodologia.length > 400 )
        {
          this.CuadroDialogo('la Descripción de la metodología supera el limite de caracteres permitido', '', true, false, 'alert', true, true)    
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;
          this.valPunto.finalizar = false;
          this.loading = false;        
          return false;
        }
        if (this.valPunto.observacionadicional != null)
        if (this.valPunto.observacionadicional.length > 1000)
        {
          this.CuadroDialogo('las Observaciones superan el limite de caracteres permitido', '', true, false, 'alert', true, true)    
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;
          this.valPunto.finalizar = false;
          this.loading = false;      
          return false;  
        }
      }
    },    

    MensajesdeValidacionFinalizar () {
        if (this.obligaValidar == true)
        {
          // empezamos a colocar las validaciones del delegado en este condicional
          if (this.tptieneavances == false && this.gindicadortipovalor.length == 0 )
            {
              this.CuadroDialogo('Debe agregar Información territorial y poblacional o seleccionar que no aplica', '', true, false, 'alert', true, true)    
              this.buttonguardarestado = false;
              this.buttonfinalizarestado = false;
              this.valPunto.finalizar = false;
              this.loading = false;
              return false;
            }
            if (this.MetasVigencia.filter(function (params) { return params.valor != null;}).length == 0 && this.MetasVigencia.filter(function (params) { return params.metaTmp != null;}).length == 0 )
            {
              this.CuadroDialogo('Debe gestionar las metas', '', true, false, 'alert', true, true)    
              this.buttonguardarestado = false;
              this.buttonfinalizarestado = false;
              this.valPunto.finalizar = false;
              this.loading = false;
              return false;
            }
            if (this.tptieneavances == false) {
              if (this.gindicadortipovalor.filter(function (params) { return params.principal ==  1;}).length == 0)
              {
                console.log('Paso 3')
                this.CuadroDialogo('Debe existir una acción territorial o poblacional marcada como principal ', '', true, false, 'alert', true, true)    
                this.buttonguardarestado = false;
                this.buttonfinalizarestado = false;
                this.valPunto.finalizar = false;
                this.loading = false;
                return false;                
              }
            }
          
        }

        if (this.valPunto.tienelineabase) {
          if (this.valPunto.lineabase == null) {
            this.loading = false;
            this.CuadroDialogo('Ingrese la linea base', '', true, false, 'alert', true, true)
            this.buttonguardarestado = false;
            this.buttonfinalizarestado = false;          
            this.valPunto.finalizar = false;            
          }
          if (this.valPunto.fechabase == null) {
            this.loading = false;
            this.CuadroDialogo('Ingrese la fecha de la linea base', '', true, false, 'alert', true, true)
            this.buttonguardarestado = false;
            this.buttonfinalizarestado = false;          
            this.valPunto.finalizar = false;            
          }          
          if (this.valPunto.descripcionlienabase == null) {
            this.loading = false;
            this.CuadroDialogo('Ingrese la descripcion de la linea base', '', true, false, 'alert', true, true)
            this.buttonguardarestado = false;
            this.buttonfinalizarestado = false;          
            this.valPunto.finalizar = false;               
          }
          if (this.valPunto.fuentebase == null) {
            this.loading = false;
            this.CuadroDialogo('Ingrese la fuente base', '', true, false, 'alert', true, true)
            this.buttonguardarestado = false;
            this.buttonfinalizarestado = false;          
            this.valPunto.finalizar = false;               
          }
        }
        
      if (!this.valPunto.tienelineabase && this.valPunto.comentariolineabase == "") 
        {
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;
          this.loading = false;
          this.CuadroDialogo('Debe argumentar la ausencia de linea base', '', true, false, 'alert', true, true)
          this.valPunto.finalizar = false;
          this.msgValidacion = true;
          return false;
        }

        if (this.valPunto.fechabase != null && this.valPunto.lineabase >= 0) {
        let validarlinea = new Date(this.valPunto.fechabase);
        if (validarlinea.getFullYear() >= this.valPunto.inicio) {
          
          this.CuadroDialogo('La fecha de linea base no puede ser mayor o igual a la fecha de medición del indicador', '', true, false, 'alert', true, true)
          this.loading = false;
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;
          this.msgValidacion = true;
          return false;
        }
        }        
      return true;
    },
    ValidacionIndependiente(){
    
      this.$validator.validateAll().then((result) => {
        console.log('Nro Errores', this.$validator.errors.items.length)
        if (result && this.$validator.errors.items.length == 0) {
          let mesageAlert = 'La ficha técnica del indicador ' + this.valPunto.nombre + ' será enviada al Departamento Nacional de Planeación para iniciar el proceso de revisión, validación y aprobación/rechazo.'
          this.CuadroDialogo('¿Enviar indicador a revisión?', mesageAlert, true, true, 'question', true, false)
          return true;
        }

        const errorFieldName = this.$validator.errors.items[0].field;
        console.log('this.$validator.errors.items[0].field', this.$validator.errors.items[0])
        console.log('errorFieldName', errorFieldName);
        this.$refs[errorFieldName].focus()
        return false;
      });
    },
    FinalizarIndicador() {
      this.$validator.validateAll().then((result) => {
        console.log(this.$validator.errors.items.length)
        if (result && this.$validator.errors.items.length == 0) {
          this.valPunto.finalizar = true;
          this.buttonguardarestado = true;
          this.buttonfinalizarestado = true;
          console.log('Finaliar Indicador')
          this.SaveIndicador();
          return;
        }
        ///este console lo vamos a dejar para ver los posibles error de validación
        console.log(this.$validator);
        this.snack = true;
        this.dialogAlert = false;
        let Errores = "";
        this.$validator.errors.items.forEach((element) => {
          Errores = Errores + "( " + element.msg + " ), ";
        });
        this.MesaggeInfo.mensajeRespuesta = "la validación del formulario contiene errores " + Errores;
        this.MesaggeInfo.color = "infovue";
      });
    },
    ValidarRevisionComentario() {
      let bag = new ErrorBag();
      bag = this.errors;
      if (bag.first('revisioncomentario') !== undefined)
        bag.removeById(bag.first('revisioncomentario').id);

      if (this.$refs.revisioncomentario.quill.root.innerHTML.length > this.$refs.revisioncomentario.quill.options.modules.counter.max && bag.first('revisioncomentario') == undefined) {
        bag.add({
          field: 'revisioncomentario',
          msg: 'está superando el límite de caracteres'
        });
      }
    },
    changepersonagerente() {
      let idpersonager = this.valPunto.idpersonagerente;
      let GerenteFiltrado = this.gpersonas.filter(function (params) {
        return params.idpersona == idpersonager;
      });
      if (GerenteFiltrado.length > 0) {
        this.personagerente.nombre = GerenteFiltrado[0].nombre;
        this.personagerente.cargo = GerenteFiltrado[0].cargo;
        this.personagerente.identidad = GerenteFiltrado[0].identidad;
        this.personagerente.dependencia = GerenteFiltrado[0].dependencia;
        this.personagerente.correo = GerenteFiltrado[0].correo;
        this.personagerente.idpersona = GerenteFiltrado[0].idpersona;
        this.personagerente.telefono = GerenteFiltrado[0].telefono;
      }
    },
    changepersonagerentebuscar() {
      let idpersonagerbuscar = this.valPunto.idpersonagerentebuscar;
      let GerenteFiltrado = this.gpersonas.filter(function (params) {
        return params.idpersona == idpersonagerbuscar;
      });
      if (GerenteFiltrado.length > 0) {
        this.personagerentebuscar.nombre = GerenteFiltrado[0].nombre;
        this.personagerentebuscar.cargo = GerenteFiltrado[0].cargo;
        this.personagerentebuscar.identidad = GerenteFiltrado[0].identidad;
        this.personagerentebuscar.dependencia = GerenteFiltrado[0].dependencia;
        this.personagerentebuscar.correo = GerenteFiltrado[0].correo;
        this.personagerentebuscar.idpersona = GerenteFiltrado[0].idpersona;
        this.personagerentebuscar.telefono = GerenteFiltrado[0].telefono;
      }
    },
    chagepersonaaprobador() {
      let idpersonaaprob = this.valPunto.idpersonaaprobador;
      let AprobadorFiltrado = this.gpersonas.filter(function (params) {
        return params.idpersona == idpersonaaprob;
      });
      if (AprobadorFiltrado.length > 0) {
        this.personaaprobador.nombre = AprobadorFiltrado[0].nombre;
        this.personaaprobador.cargo = AprobadorFiltrado[0].cargo;
        this.personaaprobador.identidad = AprobadorFiltrado[0].identidad;
        this.personaaprobador.idpersona = AprobadorFiltrado[0].idpersona;
        this.personaaprobador.correo = AprobadorFiltrado[0].correo;
      }
    },
    chagepersonaaprobadorbuscar() {
      let idpersonaaprobbuscar = this.valPunto.idpersonaaprobadorbuscar;
      let AprobadorFiltrado = this.gpersonas.filter(function (params) {
        return params.idpersona == idpersonaaprobbuscar;
      });
      if (AprobadorFiltrado.length > 0) {
        this.personaaprobadorbuscar.nombre = AprobadorFiltrado[0].nombre;
        this.personaaprobadorbuscar.cargo = AprobadorFiltrado[0].cargo;
        this.personaaprobadorbuscar.identidad = AprobadorFiltrado[0].identidad;
        this.personaaprobadorbuscar.idpersona = AprobadorFiltrado[0].idpersona;
        this.personaaprobadorbuscar.dependencia = AprobadorFiltrado[0].dependencia;
        this.personaaprobadorbuscar.correo = AprobadorFiltrado[0].correo;
      }
    },
    readcontrol(control) {
      if (this.estadocampos.length > 0) {
        let responseread = this.estadocampos.find(function (element) {
          if (element.nombre == control) {
            return element;
          }
        });

        if (responseread == null) return true;
        else {
          return responseread.lectura;
        }
      }
    },
    showcontrol(control) {
      if (this.estadocampos.length > 0) {
        let responsefound = this.estadocampos.find(function (element) {
          if (element.nombre == control) {
            return element;
          }
        });
        if (responsefound == undefined) return false;
        else return responsefound.visible;
      }
    },
    functionalert() {
      if (this.buttontext == "cerrar") {
        this.snack = false;
      }
      if (this.buttontext == "aceptar") {
        this.buttontext == "cerrar";
        this.snack = false;
        this.timeoutsnak = 4000;
        let ruta = this.returpath;
        if (ruta == "") {
          if (localStorage.pathfrom != "/") ruta = localStorage.pathfrom;
          ruta = "/tareas";
        } else if (ruta == "/") {
          ruta = "/inicio";
        }
        console.log('ruta', ruta)
        this.$router.push(ruta);
      }
    },
    usuario(idusuario) {
      if (this.gusuarios !== undefined)
        return this.gusuarios.filter((p) => p.idusuario === idusuario)[0].login;
      else return "Anonimo";
    },
    EliminarFinalizado() {
      // Estas lineas de codigo se utilizan para generar un temporal del indicador finalizado
      //================================================
      this.IndicadorFiltrado.forEach((element) => {
        if (this.valPunto.idindicador == element.indicador) {
          const index = this.IndicadorFiltrado.indexOf(element);
          this.IndicadorFiltrado.splice(index, 1);
        }
      });
      localStorage.setItem(
        "IndicadorFiltrado",
        JSON.stringify(this.IndicadorFiltrado)
      );
      //===================================================
    },
    marcarfinalizado() {
      // Estas lineas de codigo se utilizan para generar un temporal del indicador finalizado
      //================================================
      let ahora = new Date();
      let ahorafilter = new Date();
      ahorafilter.setMinutes(ahorafilter.getMinutes() - this.timewait);
      ahorafilter = new Date(ahorafilter);
      this.IndicadorFiltrado.push({
        indicador: this.valPunto.idindicador,
        fecha: ahora,
      });
      localStorage.setItem(
        "IndicadorFiltrado",
        JSON.stringify(this.IndicadorFiltrado)
      );
      //===================================================
    },
    getIDfinalizados() {
      let vfiltro = localStorage.IndicadorFiltrado;
      if (vfiltro !== undefined) {
        this.IndicadorFiltrado = JSON.parse(unescape(vfiltro));
      }

      //validamos que no hayan dado F5 despues de haber dado finalizar
      if (this.IndicadorFiltrado != undefined) {
        let GetCurrentIndicador = this.IndicadorFiltrado.filter(
          (X) => X.indicador == this.idindicador
        );
        if (GetCurrentIndicador != undefined) {
          if (GetCurrentIndicador.length > 0) {
            let mensajealerta = "El indicador " + this.idindicador + " ya fue finalizado y esta siendo procesado";
            this.snack = true;
            this.dialogAlert = false;
            this.MesaggeInfo.mensajeRespuesta = mensajealerta;
            this.MesaggeInfo.color = "infovue";

            let ruta = this.returpath;
            if (ruta == "") {
              if (localStorage.pathfrom != "/") ruta = localStorage.pathfrom;
              ruta = "/tareas";
            } else if (ruta == "/") {
              ruta = "/inicio";
            }
            console.log('ruta', ruta)
            this.$router.push(ruta);
          }
        }
      }
    },
    RefrescarMetas() {
      if (this.valPunto.idtipoacumulacion == null) {
        this.snack = true;
        this.dialogAlert = false;
        this.MesaggeInfo.mensajeRespuesta = "debe seleccionar un tipo de acumulación ";
        this.MesaggeInfo.color = "infovue";
      }
      else {
        this.isrefreshmeta = true;
        let groupmetas = [];
        groupmetas = this.MetasVigencia.concat(this.MetasCuatrenio);
        groupmetas = groupmetas.concat(this.MetasVigenciaext);
        groupmetas = groupmetas.concat(this.MetasCuatrenioext);
        if (groupmetas.length > 0) {
          this.valPunto.metaNavigation = groupmetas;
          this.loading = true;
          this.GenerarMetas({ data: this.valPunto, });
        }
      }
    },
    VerAuditoriaRegistro(item) {
      let link = "/detalleauditoria/7/" + item.idmeta;
      this.$router.push(link);
    },
    puedeeditar() {
      let opciones = this.gopciones.filter((p) => p.codigo === "O004-1-8")[0];
      return opciones != undefined;
    },
    finalizardeshabilitado() {
      return (this.buttonfinalizarestado || this.currentRol.findIndex(x => x == 1) !== -1) || (!this.valPunto.certifica);
    },
    finalizardeshabilitadodelegado() {      
      return (this.buttonfinalizarestado || this.currentRol.findIndex(x => x == 1) !== -1) || !(this.valPunto.certifica && localStorage.radicado !== undefined );
    },
    ChangeTipoAcumulacion() {
      if (this.valPunto.idtipoacumulacion > 0){ 
        if (this.gtipoacumulacion.filter(p => p.idtipoacumulacion === this.valPunto.idtipoacumulacion ).length > 0 ) {
          this.DescripcionAcumulacion = this.gtipoacumulacion.filter(p => p.idtipoacumulacion === this.valPunto.idtipoacumulacion )[0].descripcion;
        }        
        if (this.valPunto.idtipoacumulacion == 1 || this.valPunto.idtipoacumulacion == 2 || this.valPunto.idtipoacumulacion == 3) {
          this.valPunto.idorientacion = 1;
        } else if (this.valPunto.idtipoacumulacion == 5) {
          this.valPunto.idorientacion = 2;
        } else if (this.valPunto.idtipoacumulacion == 4) {
          this.valPunto.idorientacion = 3;
        } 
      }
    },
    ChangeTiposIndicador() {
      if (this.valPunto.idtipoindicador > 0)
        if (this.gtiposindicador.filter(p => p.idtipoindicador === this.valPunto.idtipoindicador ).length > 0 )
          this.DescripcionTipoIndicador = this.gtiposindicador.filter(p => p.idtipoindicador === this.valPunto.idtipoindicador )[0].descripcion;
    },
    actualizaRolaparobado(){
      // if (this.valPunto.rolaprobado == null)
      //   this.valPunto.fichaaprobada = null;

      if (this.valPunto.rolaprobado > 0 )
        if (this.valPunto.rolaprobado != 2 )
          this.valPunto.fichaaprobada = false;
    },
    SelecciondeValidador() {
      this.valPunto.rolaprobado == null;
      if (this.valPunto.fichaaprobada == false)
        if (this.valPunto.fichavalidada == true)
          if (this.valPunto.idestado == 3)
              this.valPunto.rolaprobado = 2;
    },
    LlamadoAlert(tipo){
      this.operacionAlert = tipo;
      if (tipo == 'cancelar')
      {
        this.CuadroDialogo('¿Realmente desea cancelar?', 'Se perderán todos los cambios realizados!', true, true, 'question', true, false)
      }
      if (tipo == 'guardarformulario'){
        this.guardarIndicadorSegunRol();
      }
      if (tipo == 'finalizarformulario'){
        if (this.MensajesdeValidacionFinalizar() == false) {
          console.log('arrojo error de validacion')
          return;
        } else {
          this.ValidacionIndependiente();
          console.log('aprobo validacion')
        }       
      }
      if (tipo == 'finalizarvalidador'){
        let mensajetitulo = ''
        let rolasignado = ''
        

        if ((this.valPunto.fichaaprobada) || (this.valPunto.fichavalidada)) {
          mensajetitulo = '¿Realmente desea finalizar la revisión ' + this.valPunto.codigo + ' ?';
        } else if ((!this.valPunto.fichaaprobada) || (!this.valPunto.fichavalidada)) {
          mensajetitulo = '¿Realmente desea rechazar el indicador ' + this.valPunto.codigo + ' ?';
        }
        
        this.dialogValiddor = false;
        this.CuadroDialogo(mensajetitulo, 'La ficha ' + this.valPunto.codigo + ' técnica se enviará al rol asignado en el flujo ', true, true, 'question', true, false)
      }
      if (tipo == 'eliminar'){
        this.CuadroDialogo('¿Realmente desea eliminar?', 'Se eliminarán todos los cambios realizados!', true, true, 'question', true, false)
      }
      
    },
    CuadroDialogo(titulo, subtitulo, btnAceptar, btnCancelar, icon, cargar, cerrar ){
      this.tituloAlert = titulo;
      this.subtituloAlert = subtitulo;
      this.buttonAceptarAlert =  btnAceptar;
      this.buttonCancelarAlert = btnCancelar;
      this.inconAlert = icon;
      if (cargar)
        this.dialogAlert = cargar;

      if (cerrar) {
        this.operacionAlert = 'Cerrar'
      }
    },
    ClearAlert(){
      this.tituloAlert = '';
      this.subtituloAlert = '';
      this.operacionAlert = '';
      this.buttonCancelarAlert = true;
      this.buttonAceptarAlert = true;
      this.inconAlert = '';
    },
    OperacionAprobacion(){
      if (this.operacionAlert == 'cancelar') {
        let ruta = "/tareas";
        this.$router.push(ruta);
        console.log('entro a cancelar')
      }
      if (this.operacionAlert == 'guardarformulario'){
        this.dialogAlert = false;
      }
      if (this.operacionAlert == 'finalizarformulario'){
        this.FinalizarIndicador();
      }
      if (this.operacionAlert == 'Cerrar'){
        this.dialogAlert = false;
        this.valPunto.finalizar = false;
      }
      if (this.operacionAlert == 'CerrarFormulario'){
        let ruta = this.returpath;
        if (ruta == "") {
          if (localStorage.pathfrom != "/") ruta = localStorage.pathfrom;
          ruta = "/tareas";
        } else if (ruta == "/") {
          ruta = "/inicio";
        }
        console.log('ruta', ruta)
        this.$router.push(ruta);
      }
      if (this.operacionAlert == 'finalizarvalidador'){
        this.ValidarRevisionComentario();
        this.FinalizarIndicador();
      }
      if (this.operacionAlert == 'eliminar'){
        this.dialogAlert = false;
        this.Deletemasive({ params: {idindicador: this.valPunto.idindicador } })
      }
      this.ClearAlert();
    },
    BuscarAuditoriaporRadicado(){
      this.get_soportesversion({
        params: {
          idtabla: 2, // tabla del indicador
          idradicado: this.versionadodatosadicionales.numeroradicado,
          idregistro: this.valPunto.idindicador
        },
      });      
    },
    RecivetoChildrentipoValor(msg) {
      this.loading = msg;
      console.log('this.loading', this.loading)
    },
    BotonesGenericosFlujo(value) {
      this.valPunto.respuestabuttons = value;
      if (value == "SendDT_F1"){
        this.valPunto.fichavalidada = true;
        this.LlamadoAlert('finalizarvalidador')
      }
      if (value == "DeclineDelegado_F1"){
        this.valPunto.fichavalidada = false;
        this.LlamadoAlert('finalizarvalidador')
      }
      if (value == "SendSDHP_F1"){
        this.valPunto.fichavalidada = true;
        this.LlamadoAlert('finalizarvalidador')
      }
      if (value == "RechazarSDHP_F1"){
        this.valPunto.fichavalidada = false;
        this.LlamadoAlert('finalizarvalidador')
      }
      if (value == "SendValidador_F1"){
        this.valPunto.fichavalidada = true;
        this.LlamadoAlert('finalizarvalidador')
      }
      if (value == "RechazarValidador_F1"){
        this.valPunto.fichavalidada = false;
        this.LlamadoAlert('finalizarvalidador')
      }
      if (value == "SendDT_F2"){
        this.valPunto.fichavalidada = true;
        this.valPunto.fichaaprobada = false;
        this.valPunto.rolaprobado = 9
        this.LlamadoAlert('finalizarvalidador')
      }
      if (value == "SendSDHP_F2"){
        this.valPunto.fichavalidada = true;
        this.valPunto.fichaaprobada = false;
        this.valPunto.rolaprobado = 10
        this.LlamadoAlert('finalizarvalidador')
      }
      if (value == "DeclineDelegado_F2"){
        this.valPunto.fichavalidada = true;
        this.valPunto.fichaaprobada = false;
        this.valPunto.rolaprobado = 2
        this.LlamadoAlert('finalizarvalidador')
      }
      if (value == "AprobarFT"){
        this.valPunto.fichavalidada = true;
        this.valPunto.fichaaprobada = true;
        this.valPunto.rolaprobado = null;
        this.valPunto.metaaprobada = true;
        this.LlamadoAlert('finalizarvalidador')
      } 
      if (value == "DeclineValidador_F2"){
        this.valPunto.fichavalidada = true;
        this.valPunto.fichaaprobada = false;
        this.valPunto.rolaprobado = 3;
        this.LlamadoAlert('finalizarvalidador')
      }
      if (value == "SendValidador_F2"){
        this.valPunto.fichavalidada = true;
        this.valPunto.fichaaprobada = true;
        this.valPunto.rolaprobado = 3;
        this.LlamadoAlert('finalizarvalidador')
      }      
    },
    RecibirSerie(serie){
      console.log("serie", serie)
      this.valPunto.seriehistorica = serie;
    },
    row_classes(item) {
      if (this.valPunto.avancesgenerados == true && this.valPunto.idestado != 6){
        if (item.valor != item.metaTmp) {
          return "light-blue";
        } 
      }
    },
    LLenarHeaderMetas() {
      this.headerMetasFilter = [];
          this.headerMetasFilter.push({
            value: "periodo", text: "Año", sortable: true, align: "center" });
            
          if (this.valPunto.avancesgenerados == true || (this.isUserValidador == true && this.valPunto.idestado == 3)){
              this.headerMetasFilter.push({value: "valor", text: "Meta", sortable: true, align: "center" });
          } 
          if (this.valPunto.idestado != 6){
            this.headerMetasFilter.push({value: "metaTmp", text: "Meta propuesta", sortable: true, align: "center" });
          }
          this.headerMetasFilter.push({
            value: "action", text: "Acciones", sortable: false, align: "center" });            
    },
    LLenarHeaderMetasCuat() {
      this.headerMetasCuatrFilter = [];
          this.headerMetasCuatrFilter.push({
            value: "periodo", text: "periodo", sortable: true, align: "center" });
          if (this.valPunto.avancesgenerados == true  || (this.isUserValidador == true && this.valPunto.idestado == 3)){
              this.headerMetasCuatrFilter.push({value: "valor", text: "Meta", sortable: true, align: "center" });
          }            
          if (this.valPunto.idestado != 6){
            this.headerMetasCuatrFilter.push({value: "metaTmp", text: "Meta propuesta", sortable: true, align: "center" });
          }
    }

  },
  beforeCreate() {
    this.valPunto = [];
  },
  created() {
    this.returpath = localStorage.pathfrom;
    let user = this.getusuario();
    this.isUserDelegate = user.usuarioRol.map(item => { return item.idrol == 2 })[0];
    if (this.isUserDelegate == false)
      this.isUserValidador = user.usuarioRol.map(item => { return item.idrol == 3 })[0];
    
    if (user != null) {
      this.currentRol = user.usuarioRol.map(item => { return item.idrol });
      
      user.usuarioRol.forEach(element => { if ( element.obligaValidacion == true) {
        this.obligaValidar = element.obligaValidacion } })

      let auten = user.token.replace("Bearer ", "");
      this.$aes.setKey(auten);
      let temporal = this.$route.params.idindicador.replace(/AbcYq/g, "/");
      temporal = temporal.replace(/qYcbA/g, "+");
      temporal = this.$aes.decrypt(temporal);
      temporal = temporal.substring(4);
      temporal = temporal.substring(0, temporal.length - 4);
      temporal = this.$aes.decrypt(temporal);
      this.idindicador = temporal;

      this.get_usuarios();
      this.get_comentarios({ params: { idtabla: 2, idelemento: this.idindicador, isUserDelegate: this.isUserDelegate } }) // campo meta
      this.Indicador_Encabezado({
        params: {
          idindicador: this.idindicador,
        },
      }),
        this.get_unidades(),
        this.Getperiodicidad(),
      
      this.get_lista();
      this.get_unidades();
      this.get_territorializaciones();
      
      this.get_configuraciones();
      this.getIDfinalizados();
      this.get_nacionales();
      this.get_porusuario();
      this.getmetodologias();
      this.Getorientacion();
    }
    localStorage.removeItem('radicado')
  },
  computed: {
    ...mapGetters([
      "gindicador",
      "gunidades",
      "gperiodicidad",
      "gmetas",
      "gmetasvigenciasinext",
      "gmetasvigenciaext",
      "gmetascuatreniosinext",
      "gmetascuatrenioext",
      "gtipoacumulacion",
      "gentidad",
      "ghito",
      "gpersonagerente",
      "gpersonaaprobador",
      "gpersonas",
      "gcampos",
      "gterritorializaciones",
      "gtiposindicador",
      "gconfiguraciones",
      "gtiposclasificador",
      "gtiposclasificadorfiltrado",
      "gnacionales",
      "gopciones",
      "gactualizarmetas",
      "gversionados",
      "gsectores",
      "gentidades",
      "gindicadortipovalor",
      "gTipovalorListadesagregacion",
      "gentidadreporta",
      "gmetodologias",
      "gorientacion",
      "gversionados",
      "gseries",
      "gControlesbyflujo",
      "gcomentarios",
      "gmetastemporales",
      "gtareasbyelemento",
    ]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    ...mapGetters("fichatecnica", [
      "gficha_permitenacional",
      "gficha_itemsclasificacion",
      "gficha_indicador",
    ]),
    ...mapGetters("usuario", ["gusuario", "gusuarios"]),
  },
  watch: {
    gindicador: function () {
      this.valPunto = this.gindicador;
      if (this.valPunto.tienelineabase == null)
        this.tienelineabase = false;
      else
      this.tienelineabase = this.valPunto.tienelineabase;

      this.idtipoacumulacion = this.valPunto.idtipoacumulacion;
      this.set_indicador({ indicador: this.valPunto });
      this.tipoclasificadorNavigation =
        this.valPunto.idtipoclasificadorNavigation;
      this.switchTerritorio = this.valPunto.territorialindicador;
      this.switchrequierehito = this.valPunto.requierehito;
      this.Entidadselected = [];
      this.valPunto.indicadorEntidades.forEach((element) => {
        this.Entidadselected.push(element.identidad);
      });
      this.responsableselected = [];
      this.valPunto.indicadorResponsable.forEach((element) => {
        this.responsableselected.push(element.identidad);
      });
      this.territorializacionselect = [];
      this.valPunto.indicadorTerritorializaciones.forEach((element) => {
        this.territorializacionselect.push(element.idterritorializacion);
      });

      if (this.valPunto.idclasificacionNavigation.nombre == "Étnico") {
        this.clasificacionetnico = true;
      }
    },
    valPunto: function (val) {
      this.elemento_coment = val.idindicador;
      this.get_tareaactivabytipo({ params: { idelemento: val.idindicador, idproceso: 1, idtipo: 1 } }) // obtiene los datos de la tarea actual
      this.tptieneavances = val.territorialindicador;
      this.get_series({ params: { idindicador: val.idindicador} });
      this.get_tiposclasificador();
      this.Getentidad();
      this.Gettipoacumulacion();
      this.get_TipoIndicador();
      this.LLenarHeaderMetas();
      this.LLenarHeaderMetasCuat();
      this.get_historicotareas({ params: { idtabla: "2", idelemento: val.idindicador } });
      this.get_metastemporales({ params: { idindicador: val.idindicador }});

      if (val.Entidades == null)
        this.get_entidadreporta({ params: { idindicador: val.idindicador, },});
      
        if (this.currentRol.length = 1)
          this.getControlbyFlujo({params: { idproceso: 1, idrol: this.currentRol, idestado: val.idestado},});
        
        


      this.get_camposestado({
        params: {
          idtabla: "indicador",
          idestado: val.idestado,
        },
      });
      if (!this.recargadata) {
        this.get_metasvigenciaExt({
          params: {
            idindicador: val.idindicador,
          },
        });
        this.get_metascuatrenioExt({
          params: {
            idindicador: val.idindicador,
          },
        });
      }
      this.Gethitos({
        params: {
          idindicador: val.idindicador,
        },
      });
      if (val.idpersonagerente !== null) {
        this.get_personagerente({
          params: {
            IDPersona: val.idpersonagerente,
          },
        });
      }
      if (val.idpersonaaprobador !== null) {
        this.get_personaaprobador({
          params: {
            IDPersona: val.idpersonaaprobador,
          },
        });
      }
      this.usuarioregistrado = this.getusuario();
      // Proceso que establece el estado de los botones
      if (val.idusuarioresponsable !== null) {
        if (val.idusuarioresponsable == this.usuarioregistrado.idusuario) {
          this.userautenticado = true;
        }
      }
      if (val.idrolresponsable !== null && this.userautenticado == false) {
        this.usuarioregistrado.usuarioRol.forEach((element) => {
          if (element.idrol == val.idrolresponsable) {
            this.userautenticado = true;
          }
        });
        if (val.idrolresponsable != 3)
          if (this.usuarioregistrado.identidad != val.identidad)
              this.userautenticado = false;        
      }

      if (this.userautenticado) {
        this.buttonfinalizarestado = false;
        this.buttonguardarestado = false;
      }
      if (this.admineditar) {
        this.buttonguardarestado = false;
      }

      
      if (this.gtipoacumulacion.length > 0)
        if (this.gtipoacumulacion.filter(p => p.idtipoacumulacion === this.valPunto.idtipoacumulacion ).length > 0)
          this.DescripcionAcumulacion = this.gtipoacumulacion.filter(p => p.idtipoacumulacion === this.valPunto.idtipoacumulacion )[0].descripcion;
        
        
      if (this.gtiposindicador.length > 0)
        if (this.gtiposindicador.filter(p => p.idtipoindicador === this.valPunto.idtipoindicador ).length > 0)
          this.DescripcionTipoIndicador = this.gtiposindicador.filter(p => p.idtipoindicador === this.valPunto.idtipoindicador )[0].descripcion;
      

    },
    gmetasvigenciasinext: function () {
      this.MetasVigencia = this.gmetasvigenciasinext;
    },
    gmetasvigenciaext: function () {
      this.MetasVigenciaext = this.gmetasvigenciaext;
    },
    gmetascuatreniosinext: function () {
      this.MetasCuatrenio = this.gmetascuatreniosinext;
    },
    gmetascuatrenioext: function () {
      this.MetasCuatrenioext = this.gmetascuatrenioext;
    },
    gtipoacumulacion: function () {
      this.TAcumulacion = this.gtipoacumulacion;
      if (this.gtipoacumulacion.length > 0)
        if (this.gtipoacumulacion.length > 0)
          if (this.gtipoacumulacion.filter(p => p.idtipoacumulacion === this.valPunto.idtipoacumulacion ).length > 0 )
            this.DescripcionAcumulacion = this.gtipoacumulacion.filter(p => p.idtipoacumulacion === this.valPunto.idtipoacumulacion )[0].descripcion;
    },
    gentidad: function () {
      this.Entidades = this.gentidad;
    },
    gentidadreporta: function () {
        if (this.valPunto.entidades == null) 
          this.valPunto.entidades = this.gentidadreporta
    },
    ghito: function () {
      this.Hitos = this.ghito;
      if (this.Hitos.length > 0) {
        this.switchrequierehito = true;
      }
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    },
    ginformation() {
      console.log('Cargo informacion ficha', this.loading)
      if (this.loading) {
        if (this.ginformation.idGenerado == "1") {
          this.recargadata = true;
          setTimeout(() => {
            this.Indicador_Encabezado({
              params: {
                idindicador: this.idindicador,
              },
            });
          }, 1000);
        }
        if (this.valPunto.finalizar) {
          this.buttonguardarestado = true;
          this.buttonfinalizarestado = true;
          // this.buttontext = "aceptar";
          // this.timeoutsnak = 0;
          // this.snack = true;
          // this.MesaggeInfo.mensajeRespuesta =
          //   "El proceso del indicador ha finalizado; presione aceptar para continuar";
          // this.MesaggeInfo.color = "infovue";

          // this.inconAlert = 'check';
          // this.tituloAlert = '¡El indicador fue enviado correctamente!';
          // this.subtituloAlert = '';
          // this.buttonAceptarAlert =  true;
          // this.buttonCancelarAlert = false;
          this.CuadroDialogo('¡El indicador fue enviado correctamente!', '', true, false, 'check', true, true)
          this.operacionAlert = 'CerrarFormulario';

        } else {
          this.EliminarFinalizado();
          this.MesaggeInfo = this.ginformation;
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;  
          this.CuadroDialogo('', this.MesaggeInfo.mensajeRespuesta, true, false, 'alert', true, true)
          console.log(this.MesaggeInfo.mensajeRespuesta);
          //este console por favor dejarlo, es para que el usuario tenga en consola los posibles mensajes por si no alcanza a leerlo
        }
        this.loading = false;
        store.dispatch("mensaje/set_reset");
      }
    },
    switchTerritorio() {
      this.valPunto.territorialindicador = this.switchTerritorio;
      if (!this.switchTerritorio) {
        this.territorializacionselect = [];
      }
    },
    switchrequierehito() {
      this.valPunto.requierehito = this.switchrequierehito;
      if (this.switchrequierehito) {
        if (this.valPunto.idrolresponsable == 3) {
          this.snack = true;
          this.dialogAlert = false;
          this.MesaggeInfo.mensajeRespuesta =
            "Recuerde revisar los hitos asociados al indicador";
          this.MesaggeInfo.color = "infovue";
        } else {
          this.snack = true;
          this.dialogAlert = false;
          this.MesaggeInfo.mensajeRespuesta =
            "Para agregar hitos seleccione la opción hitos del menú";
          this.MesaggeInfo.color = "infovue";
        }
      }
      if (!this.switchrequierehito) {
        this.valPunto.hito = [];
        this.Hitos = [];
      }
    },
    gpersonagerente() {
      this.personagerente.nombre = this.gpersonagerente.nombre;
      this.personagerente.cargo = this.gpersonagerente.cargo;
      this.personagerente.identidad = this.gpersonagerente.identidad;
      this.personagerente.dependencia = this.gpersonagerente.dependencia;
      this.personagerente.correo = this.gpersonagerente.correo;
      this.personagerente.telefono = this.gpersonagerente.telefono;
      this.personagerente.idpersona = this.gpersonagerente.idpersona;
    },
    gpersonaaprobador() {
      this.personaaprobador.nombre = this.gpersonaaprobador.nombre;
      this.personaaprobador.cargo = this.gpersonaaprobador.cargo;
      this.personaaprobador.identidad = this.gpersonaaprobador.identidad;
      this.personaaprobador.idpersona = this.gpersonaaprobador.idpersona;
      this.personaaprobador.correo = this.gpersonaaprobador.correo;
    },
    gpersonas() {
      this.personas = this.gpersonas;
    },
    gcampos() {
      this.estadocampos = this.gcampos;
      //this.campo_coment = this.gcampos.filter(p => p.nombre === "metodologiamedicion")[0].idcampo;
      let responsegerente = this.estadocampos.find(function (element) {
        if (element.nombre == "idpersonagerente") {
          return element.habilitado;
        }
      });
      if (responsegerente) {
        this.colorGerenteMeta = "gray";
      }

      let responseaprobador = this.estadocampos.find(function (element) {
        if (element.nombre == "idpersonaaprobador") {
          return element.habilitado;
        }
      });
      if (responseaprobador) {
        this.colorAprobador = "gray";
      }

      this.estadorevision = this.showcontrol("comentarioflujo");
    },
    isEditingGerente: function () {
      this.colorGerenteMeta = "gray";
      let responsefound = this.estadocampos.find(function (element) {
        if (element.nombre == "idpersonagerente") {
          return element;
        }
      });
      if (this.isEditingGerente == true && responsefound.habilitado == false) {
        this.colorGerenteMeta = "success";
      } else if (
        this.isEditingGerente == false &&
        responsefound.habilitado == false
      ) {
        this.colorGerenteMeta = "info";
      }
    },
    isEditingAprobador: function () {
      this.colorAprobador = "gray";
      let responsefound = this.estadocampos.find(function (element) {
        if (element.nombre == "idpersonaaprobador") {
          return element;
        }
      });
      if (
        this.isEditingAprobador == true &&
        responsefound.habilitado == false
      ) {
        this.colorAprobador = "success";
      } else if (
        this.isEditingAprobador == false &&
        responsefound.habilitado == false
      ) {
        this.colorAprobador = "info";
      }
    },
    tienelineabase: function () {
      console.log('tienelineabase', this.tienelineabase)
      if (this.tienelineabase) {
        this.valPunto.tienelineabase = true;
        this.valPunto.comentariolineabase = "";
      } else {
        this.valPunto.tienelineabase = false;
        this.valPunto.lineabase = null;
        this.valPunto.fuentebase = "";
        this.valPunto.descripcionlienabase = "";
      }
    },
    gconfiguraciones() {
      
      this.tiposarchivo = this.gconfiguraciones.filter(
        p => p.codigo === "TiposArchivo"
      )[0].valor;
      this.tamanoarchivo = this.gconfiguraciones.filter(
        p => p.codigo === "TamanoArchivo"
      )[0].valor;
      this.tamanopaquete = this.gconfiguraciones.filter(
        p => p.codigo === "TamanoPaquete"
      )[0].valor;
      let GetConfigtime = this.gconfiguraciones.filter(
        (X) => X.codigo == "TiempoEspera"
      )[0];
      if (GetConfigtime != undefined) {
        this.timewait = GetConfigtime.valor;
      }
    },
    gopciones: function () {
      //Validamos si el usuario tiene un permiso especial para editar el formulario
      let SearchOpcion = this.gopciones.filter((record) => {
        return record.codigo == "O004";
      });
      if (SearchOpcion.length > 0) {
        let HijosOpcion = SearchOpcion[0].hijos;
        let Subtitle = HijosOpcion.filter((record) => {
          return record.codigo == "O004-1";
        });
        if (Subtitle.length > 0) {
          HijosOpcion = [];
          HijosOpcion = Subtitle[0].hijos;
          Subtitle = [];
          Subtitle = HijosOpcion.filter((record) => {
            return record.codigo == "O004-1-6";
          });
          if (Subtitle.length > 0) {
            this.admineditar = true;
            this.buttonguardarestado = false;
          }
        }
      }
    },
    gtiposclasificadorfiltrado: function () {
      this.ItemsClasificador = [];
      if (this.gtiposclasificadorfiltrado.length > 0) {
        this.gtiposclasificadorfiltrado.forEach((element) => {
          this.ItemsClasificador.push(element.idtipoclasificador);
        });
      }
      this.set_itemsclasificacion({
        itemsclasificacion: this.ItemsClasificador,
      });
    },
    gtiposclasificador: function () {
      this.get_tiposclasificadorbyindicador({
        params: {
          IdIndicador: this.valPunto.idindicador,
        },
      });
    },
    gactualizarmetas() {
      
      if (this.isUserDelegate == false) {
        if (this.isrefreshmeta == true) {
          this.MetasVigencia = this.gactualizarmetas.metaNavigation.filter(record => { return record.tipoPeriodicidad == "V";; });
          this.isrefreshmeta = false;
        }
      }
      this.loading = false;
      if (this.gactualizarmetas.metaNavigation.filter(X => X.extemporaneo == false).length > 0) {
        
        if (this.gactualizarmetas.metaNavigation.filter(X => X.extemporaneo == false && X.tipoPeriodicidad == "C").length > 0)
          this.MetasCuatrenio = this.gactualizarmetas.metaNavigation.filter(X => X.extemporaneo == false && X.tipoPeriodicidad == "C");
        else
          this.MetasCuatrenio = this.gactualizarmetas.metaNavigation.filter(X => X.extemporaneo == false);
      }

      if (this.gactualizarmetas.metaNavigation.filter(X => X.extemporaneo == true).length > 0) {
        if (this.gactualizarmetas.metaNavigation.filter(X => X.extemporaneo == true && X.tipoPeriodicidad == "C").length > 0)
          this.MetasCuatrenioext = this.gactualizarmetas.metaNavigation.filter(X => X.extemporaneo == true && X.tipoPeriodicidad == "C");
        else
          this.MetasCuatrenioext = this.gactualizarmetas.metaNavigation.filter(X => X.extemporaneo == true);
      }




      this.valPunto.meta = this.gactualizarmetas.meta;
      this.valPunto.metaparcial = this.gactualizarmetas.metaparcial;
      if (this.MetasCuatrenioext.length > 0)
        this.MetasVigenciaext.slice(-1)[0].valor = this.MetasCuatrenioext.slice(-1)[0].valor;
      else
        if (this.MetasVigenciaext.length > 0) {
          this.MetasVigenciaext.slice(-1)[0].valor = (this.valPunto.meta - this.valPunto.reporte);
        }


    },
    //Soportes
    gversionados: function () {
      this.cargando = false;
      this.versiones = this.gversionados;

    },
    versionadodatosadicionales: function() {
      if (this.versionadodatosadicionales.fecharadicadoformateada != '') {
        
        this.fechaformateada = this.formato(this.versionadodatosadicionales.fecharadicadoformateada, true);
      }
    },
    fecharadicado() {
      if (this.fecharadicado != '') {
        
        this.fechaformateada = this.formato(this.fecharadicado, true);
        this.versionadodatosadicionales.fecharadicado = this.fecharadicado;
      }
    },
    gsectores: function() {
      if (this.entidades != undefined)
        this.sector = this.gsectores.filter((p) => p.idsector === this.entidades[0].idsector)[0];
      
    },
    gentidades: function() {
      let temp = this.gentidades.filter((p) => p.identidad === this.valPunto.identidad )[0];
      if (temp != undefined) {
        this.entidades = this.gentidades.filter(p=> p.idsector === temp.idsector );
        this.get_sectores();
      }  
    },
    TodasEntidades: function() {
      if (this.TodasEntidades)
      {
        this.Entidadselected = [];
        this.Entidades.forEach(element => {
          this.Entidadselected.push(element.identidad);
        });
      } else 
      {
        this.Entidadselected = [];
      }

    },
    gversionados: function() {
      if (this.gversionados.length > 0) {
        this.versionadodatosadicionales = {
              idversionadodatosadicionales: this.gversionados[0].idversionadodatosadicionalesNavigation.idversionadodatosadicionales,
              comentario: this.gversionados[0].idversionadodatosadicionalesNavigation.comentario,
              numeroradicado: this.gversionados[0].idversionadodatosadicionalesNavigation.numeroradicado,
              fecharadicado: this.gversionados[0].idversionadodatosadicionalesNavigation.fecharadicadoformateada
            }
          this.fechaformateada = this.formato(this.gversionados[0].idversionadodatosadicionalesNavigation.fecharadicadoformateada, true); 
          this.fecharadicado = this.gversionados[0].idversionadodatosadicionalesNavigation.fecharadicadoformateada;
          this.soportes = [];
          localStorage.setItem('radicado', this.gversionados[0].idversionadodatosadicionalesNavigation.numeroradicado)
          this.gversionados[0].versionadoSoporte.forEach(element => {
            this.soportes.push(element.idsoporteNavigation)
          });
          this.idregistro = this.gversionados[0].idregistro
        }
      console.log('this.versionadodatosadicionales', this.versionadodatosadicionales)
    },
    gseries: function() {
      this.LoadingSeries = false; 
      if (this.gseries.length > 0)
      {
        this.rangeyears[0] = parseInt(this.gseries[0].nombreperiodo)
        this.rangeyears[1] = parseInt(this.gseries[this.gseries.length - 1].nombreperiodo)
        this.valPunto.serieinicio = this.rangeyears[0];
        this.valPunto.seriefin = this.rangeyears[1];
        this.tieneseriehistorica = true;
      }


    }, 
    tptieneavances: function() {
      console.log('this.tptieneavances', this.tptieneavances)
      this.valPunto.territorialindicador = this.tptieneavances
      if (this.tptieneavances && this.gindicadortipovalor.length > 0) {
        this.LlamadoAlert('eliminar')
        this.loading = true;
      } 
    },
    dialogAlert: function() {
      if (this.dialogAlert == false && this.tptieneavances == true)
      {
        this.loading = false;
      }
      if (this.dialogAlert == false && this.operacionAlert == 'eliminar'){
        this.valPunto.territorialindicador = false;
        this.tptieneavances = false;
      }
        
    },
    gindicadortipovalor: function() {
      this.loading = false;
    },
    gTipovalorListadesagregacion: function () {
      this.loading = false;
    },
    tieneseriehistorica: function() {
      this.LoadingSeries = false;
      if (this.tieneseriehistorica == true && this.gseries.length == 0)
      {
        let user = this.getusuario();
        let RolDelegado = user.usuarioRol.map(item => { return item.idrol == 2 });
        if (RolDelegado[0] == true && (this.valPunto.idestado == 1 || this.valPunto.idestado == 2))
          this.get_generar({ params: { idindicador: this.valPunto.idindicador}});        
      } else if (this.tieneseriehistorica == true && this.gseries.length > 0) {
        this.rangeyears[0] = parseInt(this.gseries[0].nombreperiodo)
        this.rangeyears[1] = parseInt(this.gseries[this.gseries.length - 1].nombreperiodo)
        this.valPunto.serieinicio = this.rangeyears[0];
        this.valPunto.seriefin = this.rangeyears[1];
      } else if (this.tieneseriehistorica == false){
        this.rangeyears[0] = null;
        this.rangeyears[1] = null;
        this.valPunto.serieinicio = null;
        this.valPunto.seriefin = null;
      }
    },
    gtareasbyelemento: function() {
      
      if (this.gtareasbyelemento.idrol != undefined){
        if (this.gtareasbyelemento.idrol != null){
          console.log('this.gtareasbyelemento', this.gtareasbyelemento.idrol)
          this.idrolseguntarea = this.currentRol.filter((p) => p === this.gtareasbyelemento.idrol )[0]
          console.log('this.idrolseguntarea', this.idrolseguntarea)
          
          if (this.currentRol.length > 1)
            this.getControlbyFlujo({params: { idproceso: 1, idrol: this.idrolseguntarea, idestado: val.idestado},});

        }
      }
    }
  },
};
</script>

<style>
.btnimg {
  flex: inherit !important;
}

.ql-container {
  font-family: "Work Sans" !important;
  color: #000;
}

/* .hide-scrollbar::-webkit-scrollbar {
    display: none;
  }

.hide-scrollbar{
   overflow: hidden;
} */

.hidenscrollbar {
   -ms-overflow-style: none;  /* IE and Edge */
   scrollbar-width: none;  /* Firefox */
   overflow: hidden;
   
}

</style>
